{
  "account.account": "Profil a zabezpečenie",
  "account.accountDeleted": "Váš účet bol úspešne odstránený.",
  "account.accountDescription": "Meno, heslo, odstránenie účtu",
  "account.accountSection": "Účet",
  "account.changeEmail": "Zmeniť e-mail",
  "account.changePassword": "Zmeniť heslo",
  "account.currentPassword": "Aktuálne heslo",
  "account.dangerZone": "Riziková zóna",
  "account.deleteAccount": "Odstrániť účet",
  "account.deleteAccountConfirmation": "Naozaj chcete odstrániť svoj účet? Táto akcia je nezvratná.",
  "account.deleteAccountDescription": "Táto akcia odstráni váš účet a všetky vaše informácie. Už niet cesty späť.",
  "account.emailChange": "Zmeniť e-mailovú adresu",
  "account.emailChangeConfirmation": "Potvrdenie zmeny e-mailu",
  "account.emailChangeFailure": "Odkaz na zmenu e-mailu je neplatný alebo vypršal.",
  "account.emailChangeIntro": "Zadajte svoju novú e-mailovú adresu a aktuálne heslo. Na novú adresu vám pošleme odkaz: e-mail sa zmení až po jeho otvorení.",
  "account.emailChangeSuccess": "Váš e-mail bol úspešne zmenený na {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Vaša e-mailová adresa bola úspešne zmenená.",
  "account.emailChangeVerificationSent": "Na vašu novú e-mailovú adresu bol odoslaný overovací e-mail. Skontrolujte svoju doručenú poštu a kliknite na odkaz na potvrdenie zmeny.",
  "account.manageAccount": "Spravovať účet",
  "account.newEmailAddress": "Nová e-mailová adresa",
  "account.newPassword": "Nové heslo",
  "account.newPasswordAgain": "Nové heslo znova",
  "account.oldPassword": "Staré heslo",
  "account.passwordChange": "Zmena hesla",
  "account.passwordChangeDescription": "Udržujte svoj účet v bezpečí",
  "account.passwordUpdated": "Heslo bolo úspešne aktualizované.",
  "account.profile": "Profil",
  "account.profileUpdated": "Profil bol úspešne aktualizovaný.",
  "account.signedInAs": "Prihlásený ako",
  "account.updateYourProfile": "Aktualizujte svoj profil",
  "account.updateYourProfileDescription": "Meno a predvoľby zobrazenia",
  "addons.accountOnHold": "Pripojenie vášho účtu vypršalo. Pre obnovenie aktualizácií údajov sa prosím znovu pripojte.",
  "addons.accountOnHoldTitle": "Účet pozastavený",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Vytvorte a získajte svoj kľúč API z tohto odkazu",
  "addons.ambientWeatherDescription": "Meteorologické stanice Ambient Weather (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "Kľúč API",
  "addons.applicationKey": "Aplikačný kľúč",
  "addons.availableServices": "Dostupné",
  "addons.cannotDisconnectLastAccount": "Nie je možné odpojiť jedinú metódu prihlásenia. Najprv pridajte inú metódu prihlásenia.",
  "addons.connect": "Pripojiť",
  "addons.connected": "Pripojené",
  "addons.connectedAccounts": "Prepojené účty",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "Načítavajú sa prepojené účty…",
  "addons.connectedServices": "Pripojené",
  "addons.connectedSince": "Pripojené od {date}",
  "addons.connectionSection": "Pripojenie",
  "addons.connectionSuccess": "Účet {provider} úspešne pripojený",
  "addons.davisApiSecret": "API Secret",
  "addons.davisApiV2Key": "Kľúč API V2",
  "addons.davisDescription": "Davis meteorologické stanice (Vantage Vue, Vantage Pro2, ...)",
  "addons.davisRetrieveApiKey": "Získajte svoje kľúče API V2 z tohto odkazu",
  "addons.disconnect": "Odpojiť",
  "addons.disconnectConfirmation": "Naozaj chcete odpojiť svoj účet {provider}?",
  "addons.disconnectEnergyConfirmation": "SmartMixin prestane synchronizovať službu Netatmo Energy a odstráni vaše domovy zo SmartMixinu. Váš účet Netatmo ani vaše zariadenia tým nebudú dotknuté.",
  "addons.disconnectEnergyDescription": "Zastaví synchronizáciu a odstráni vaše domovy zo SmartMixinu.",
  "addons.disconnectionSuccess": "Účet {provider} úspešne odpojený",
  "addons.disconnectProviderDescription": "Zastaví synchronizáciu a odstráni stanice tejto služby vrátane ich histórie.",
  "addons.disconnectServiceConfirmation": "SmartMixin prestane synchronizovať službu {provider} a odstráni jej stanice vrátane celej ich histórie. Samotný váš účet {provider} tým nebude dotknutý.",
  "addons.disconnectServiceTitle": "Odpojiť službu {provider}?",
  "addons.ecowittCreateAndRetrieveKeys": "Vytvorte a získajte kľúč API aj kľúč aplikácie z tohto odkazu",
  "addons.ecowittDescription": "Ecowitt poskytuje profesionálnu wifi meteostanicu, bezdrôtové vnútorné a vonkajšie teplomery, monitory vlhkosti, vysoko presné dažďové meradlá, monitory kvality vzduchu a ďalšie.",
  "addons.helpLink": "Ako pripojiť {provider}",
  "addons.integrationsSection": "Integrácie",
  "addons.myAcuriteAccountOnHold": "Váš účet bol pozastavený. Ak chcete znova pripojiť svoj účet, zadajte svoje heslo",
  "addons.myAcuriteDescription": "AcuRite je značka meteorologických staníc číslo 1 v Severnej Amerike. Ako líder v technológii času, teploty a počasia vám AcuRite poskytuje podrobné informácie o vašom vnútornom a vonkajšom prostredí, aby ste si mohli s istotou naplánovať svoj deň.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Použite svoj termostat Netatmo na zmenu teploty vášho domova, či už z postele alebo z druhého konca sveta.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Vaša osobná meteorologická stanica doma",
  "addons.notConnected": "Nepripojené",
  "addons.or": "alebo",
  "addons.providerAccountDisconnected": "Pripojenie k vašej meteorologickej službe vypršalo. Pre obnovenie aktualizácií údajov sa prosím znovu pripojte.",
  "addons.reconnect": "Znovu pripojiť",
  "addons.socialConnectionsIntro": "Prepojte svoje sociálne účty pre rýchle prihlásenie. Účty môžete kedykoľvek pripojiť alebo odpojiť.",
  "addons.weatherflowAccessToken": "Prístupový token",
  "addons.weatherflowCreateToken": "Vytvorte a získajte svoj token z tohto odkazu",
  "addons.weatherflowTempestDescription": "Tempest Weather System so vstavaným meračom vetra a dažďovým meračom",
  "addons.weatherServices": "Meteorologické služby",
  "addons.weatherServicesConnected": "{count, plural, =0 {Žiadne pripojené služby} one {# pripojená služba} few {# pripojené služby} many {# pripojených služieb} other {# pripojených služieb}}",
  "addons.weatherServicesDescription": "Pripojte Netatmo, Davis, Weatherflow a ďalšie",
  "addons.wundergroundApiKey": "Kľúč API",
  "addons.wundergroundDescription": "Weather Underground je globálna komunita ľudí, ktorí spájajú údaje z environmentálnych senzorov, ako sú meteorologické stanice a monitory kvality ovzdušia, aby sme vám mohli poskytnúť bohaté, hyperlokálne údaje, ktoré potrebujete na to, aby ste podporili svoje vášne.",
  "addons.wundergroundRemoveStationDescription": "Stanica bude odstránená z vášho účtu SmartMixin. Ak ju nepridal aj iný účet SmartMixin, stanica aj história, ktorú pre ňu SmartMixin zaznamenal, sa odstránia. Vo Weather Underground sa nič nezmení.",
  "addons.wundergroundRemoveStationTitle": "Odstrániť {station}?",
  "addons.wundergroundRetrieveApiKey": "Získajte kľúč API z tohto odkazu",
  "addons.wundergroundStationId": "ID stanice",
  "airQuality.adviceActivityGood": "Ideálny deň na pohyb vonku",
  "airQuality.adviceActivityHazardous": "Vyhnite sa akejkoľvek fyzickej aktivite vonku",
  "airQuality.adviceActivityLabel": "Fyzická aktivita",
  "airQuality.adviceActivityModerate": "Dobrý deň na pohyb vonku",
  "airQuality.adviceActivitySensitive": "Zvážte kratšie a menej náročné aktivity vonku",
  "airQuality.adviceActivityUnhealthy": "Obmedzte dlhé alebo náročné aktivity a robte viac prestávok",
  "airQuality.adviceActivityVeryUnhealthy": "Vyhnite sa dlhým alebo náročným aktivitám; zvážte presun dovnútra",
  "airQuality.adviceGroupsGood": "Nie sú potrebné žiadne zvláštne opatrenia",
  "airQuality.adviceGroupsHazardous": "Zostaňte vnútri a obmedzte aktivitu",
  "airQuality.adviceGroupsLabel": "Citlivé skupiny",
  "airQuality.adviceGroupsModerate": "Nezvyčajne citliví ľudia: kratšie a menej náročné aktivity",
  "airQuality.adviceGroupsSensitive": "Kratšie a menej náročné aktivity vonku a viac prestávok",
  "airQuality.adviceGroupsUnhealthy": "Vyhnite sa dlhým alebo náročným aktivitám vonku; zvážte presun dovnútra",
  "airQuality.adviceGroupsVeryUnhealthy": "Vyhnite sa akejkoľvek fyzickej aktivite vonku; odložte ju alebo presuňte dovnútra",
  "airQuality.adviceTimingLabel": "Kedy ísť von",
  "airQuality.adviceTimingMorning": "Najlepšie dopoludnia — ozón je vtedy nižší",
  "airQuality.airQuality": "Kvalita ovzdušia",
  "airQuality.airQualityIndex": "Index kvality ovzdušia",
  "airQuality.aqiForecast": "Predpoveď kvality ovzdušia",
  "airQuality.co2Fresh": "Čerstvý",
  "airQuality.co2GettingStale": "Mierne vydýchaný",
  "airQuality.co2Stale": "Vydýchaný",
  "airQuality.dailyForecast": "Denná predpoveď",
  "airQuality.dominantPollutant": "Dominantná znečisťujúca látka",
  "airQuality.expectedPeak": "Očakávaný vrchol",
  "airQuality.good": "Dobrá",
  "airQuality.goodDescription": "Kvalita ovzdušia sa považuje za uspokojivú a znečistenie ovzdušia predstavuje malé alebo žiadne riziko",
  "airQuality.hazardous": "Nebezpečná",
  "airQuality.hazardousDescription": "Zdravotné upozornenie: ktokoľvek môže pociťovať vážnejšie zdravotné účinky",
  "airQuality.indoorAirQuality": "Kvalita vnútorného vzduchu",
  "airQuality.moderate": "Priemerná",
  "airQuality.moderateDescription": "Kvalita vzduchu je prijateľná; pri niektorých znečisťujúcich látkach však môže existovať mierny zdravotný problém u veľmi malého počtu ľudí, ktorí sú nezvyčajne citliví na znečistenie ovzdušia.",
  "airQuality.noForecastForLocation": "Pre toto miesto nie je k dispozícii predpoveď kvality ovzdušia.",
  "airQuality.now": "Teraz",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Znečisťujúce látky",
  "airQuality.recommendations": "Odporúčania",
  "airQuality.sensitiveUnhealthy": "Nezdravá pre citlivé skupiny",
  "airQuality.sensitiveUnhealthyDescription": "Členovia citlivých skupín môžu pociťovať zdravotné účinky. Širokej verejnosti sa to pravdepodobne nedotkne.",
  "airQuality.subIndex": "Čiastkový index AQI",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Porozumieť indexu",
  "airQuality.unhealthy": "Nezdravá",
  "airQuality.unhealthyDescription": "Každý môže začať pociťovať účinky na zdravie; členovia citlivých skupín môžu pociťovať vážnejšie zdravotné účinky",
  "airQuality.veryUnhealthy": "Veľmi nezdravá",
  "airQuality.veryUnhealthyDescription": "Zdravotné varovania pred núdzovými podmienkami. Je pravdepodobnejšie, že bude postihnutá celá populácia.",
  "alerts.addAlert": "Pridať upozornenie",
  "alerts.addCondition": "Pridať podmienku",
  "alerts.alertAdded": "Upozornenie bolo úspešne pridané",
  "alerts.alertAuthorizationNotice": "Upozornenia fungujú iba vtedy, ak povolíte SmartMixin na zobrazovanie upozornení",
  "alerts.alertDeleted": "Upozornenie bolo úspešne odstránené",
  "alerts.alertName": "Názov upozornenia",
  "alerts.alertWhen": "Chcem byť upozornený, keď:",
  "alerts.aqiGreaterThan": "AQI viac ako",
  "alerts.aqiGreaterThanThreshold": "AQI je vyššie ako prahová hodnota {value}{unit}",
  "alerts.aqiLessThan": "AQI menej ako",
  "alerts.aqiLessThanThreshold": "AQI je menej ako prahová hodnota {value}{unit}",
  "alerts.atLeastOneCondition": "Musíte pridať aspoň jednu podmienku",
  "alerts.co2GreaterThan": "CO2 viac ako",
  "alerts.co2GreaterThanThreshold": "CO2 je vyššie ako prahová hodnota {value}{unit}",
  "alerts.co2LessThan": "CO2 menej ako",
  "alerts.co2LessThanThreshold": "CO2 je menej ako prahová hodnota {value}{unit}",
  "alerts.conditions": "Podmienky",
  "alerts.conditionsDroppedOnStationChange": "Táto stanica nepodporuje, odstránené: {conditions}",
  "alerts.createAlert": "Vytvoriť upozornenie",
  "alerts.dailyPrecipitationGreaterThan": "Denné zrážky väčšie ako",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Denné zrážky nad prahom {value}{unit}",
  "alerts.deleteAlert": "Odstrániť upozornenie",
  "alerts.editAlert": "Upraviť upozornenie",
  "alerts.editCondition": "Upraviť podmienku",
  "alerts.gustSpeedGreaterThan": "Rýchlosť nárazu väčšia ako",
  "alerts.gustSpeedGreaterThanThreshold": "Rýchlosť nárazu vetra je väčšia ako prahová hodnota {value}{unit}",
  "alerts.gustSpeedLessThan": "Rýchlosť nárazu menšia ako",
  "alerts.gustSpeedLessThanThreshold": "Rýchlosť nárazu vetra je nižšia ako prahová hodnota {value}{unit}",
  "alerts.heatIndexGreaterThan": "Tepelný index viac ako",
  "alerts.heatIndexGreaterThanThreshold": "Tepelný index je viac ako prahová hodnota {value}{unit}",
  "alerts.heatIndexLessThan": "Tepelný index menej ako",
  "alerts.heatIndexLessThanThreshold": "Tepelný index je menej ako prahová hodnota {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex viac ako",
  "alerts.humidexGreaterThanThreshold": "Humidex je viac ako prahová hodnota {value}{unit}",
  "alerts.humidexLessThan": "Humidex menej ako",
  "alerts.humidexLessThanThreshold": "Humidex je menej ako prahová hodnota {value}{unit}",
  "alerts.humidityGreaterThan": "Vlhkosť väčšia ako",
  "alerts.humidityGreaterThanThreshold": "Vlhkosť je vyššia ako prahová hodnota {value}{unit}",
  "alerts.humidityLessThan": "Vlhkosť menšia ako",
  "alerts.humidityLessThanThreshold": "Vlhkosť je nižšia ako prahová hodnota {value}{unit}",
  "alerts.inProgress": "Prebieha",
  "alerts.leafWetnessGreaterThan": "Vlhkosť listov väčšia ako",
  "alerts.leafWetnessGreaterThanThreshold": "Vlhkosť listov je vyššia ako prahová hodnota {value}{unit}",
  "alerts.leafWetnessLessThan": "Vlhkosť listov menšia ako",
  "alerts.leafWetnessLessThanThreshold": "Vlhkosť listov je nižšia ako prahová hodnota {value}{unit}",
  "alerts.myAlerts": "Moje upozornenia",
  "alerts.noConfiguredAlert": "Zatiaľ nemáte nakonfigurované žiadne upozornenia, pridajte si ich",
  "alerts.noiseGreaterThan": "Hluk vyšší ako",
  "alerts.noiseGreaterThanThreshold": "Hluk je vyšší ako prahová hodnota {value}{unit}",
  "alerts.noiseLessThan": "Hluk nižší ako",
  "alerts.noiseLessThanThreshold": "Hluk nižší ako prahová hodnota {value}{unit}",
  "alerts.noteOnConditions": "Upozornenie sa spustí, keď sa overia všetky nižšie uvedené podmienky",
  "alerts.noTriggerHistory": "Toto upozornenie zatiaľ nebolo spustené.",
  "alerts.pm10GreaterThan": "PM 10 viac ako",
  "alerts.pm10GreaterThanThreshold": "PM 10 je vyššie ako prahová hodnota {value}{unit}",
  "alerts.pm10LessThan": "PM 10 menej ako",
  "alerts.pm10LessThanThreshold": "PM 10 je menej ako prahová hodnota {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 viac ako",
  "alerts.pm1GreaterThanThreshold": "PM 1 je vyššie ako prahová hodnota {value}{unit}",
  "alerts.pm1LessThan": "PM 1 menej ako",
  "alerts.pm1LessThanThreshold": "PM 1 je menej ako prahová hodnota {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2,5 viac ako",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 je vyššie ako prahová hodnota {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2,5 menej ako",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 je menej ako prahová hodnota {value}{unit}",
  "alerts.postStormSummary": "Súhrn po daždi",
  "alerts.postStormSynopsisHelper": "Po skončení každého dažďa dostanete súhrnné oznámenie.",
  "alerts.postStormSynopsisSoleCondition": "Súhrn po daždi nemožno kombinovať s inými podmienkami.",
  "alerts.precipitationGreaterThan": "Hodinové zrážky väčšie ako",
  "alerts.precipitationGreaterThanThreshold": "Hodinové zrážky nad prahom {value}{unit}",
  "alerts.pressureGreaterThan": "Tlak väčší ako",
  "alerts.pressureGreaterThanThreshold": "Tlak je vyšší ako prahová hodnota {value}{unit}",
  "alerts.pressureLessThan": "Tlak menší ako",
  "alerts.pressureLessThanThreshold": "Tlak je nižší ako prahová hodnota {value}{unit}",
  "alerts.rainRateGreaterThan": "Intenzita dažďa väčšia ako",
  "alerts.rainRateGreaterThanThreshold": "Intenzita dažďa nad prahom {value}{unit}",
  "alerts.sensorNotReporting": "Tento senzor momentálne neposiela údaje. Upozornenie sa obnoví, keď ich začne znova posielať.",
  "alerts.soilMoistureGreaterThan": "Vlhkosť pôdy väčšia ako",
  "alerts.soilMoistureGreaterThanThreshold": "Vlhkosť pôdy je vyššia ako prahová hodnota {value}{unit}",
  "alerts.soilMoistureLessThan": "Vlhkosť pôdy menšia ako",
  "alerts.soilMoistureLessThanThreshold": "Vlhkosť pôdy je nižšia ako prahová hodnota {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Slnečné žiarenie väčšie ako",
  "alerts.solarRadiationGreaterThanThreshold": "Slnečné žiarenie je vyššie ako prahová hodnota {value}{unit}",
  "alerts.solarRadiationLessThan": "Slnečné žiarenie menej ako",
  "alerts.solarRadiationLessThanThreshold": "Slnečné žiarenie je nižšie ako prahová hodnota {value}{unit}",
  "alerts.stationNoLongerReports": "Táto stanica už neposiela údaje, preto sa toto upozornenie nemôže spustiť.",
  "alerts.stormChartUnavailable": "História zrážok pre tento dážď nie je k dispozícii.",
  "alerts.stormDetail": "Súhrn dažďa",
  "alerts.stormDuration": "Trvanie",
  "alerts.stormEnd": "Koniec",
  "alerts.stormPeakRate": "Maximálna intenzita dažďa",
  "alerts.stormStart": "Začiatok",
  "alerts.stormTotal": "Celkové zrážky",
  "alerts.temperatureGreaterThan": "Teplota vyššia ako",
  "alerts.temperatureGreaterThanThreshold": "Teplota je vyššia ako prahová hodnota {value}{unit}",
  "alerts.temperatureLessThan": "Teplota nižšia ako",
  "alerts.temperatureLessThanThreshold": "Teplota je nižšia ako prahová hodnota {value}{unit}",
  "alerts.thresholdOutOfRange": "Musí byť medzi {min} a {max}",
  "alerts.thswGreaterThan": "THSW viac ako",
  "alerts.thswGreaterThanThreshold": "THSW je viac ako prahová hodnota {value}{unit}",
  "alerts.thswLessThan": "THSW menej ako",
  "alerts.thswLessThanThreshold": "THSW je menej ako prahová hodnota {value}{unit}",
  "alerts.thwGreaterThan": "THW viac ako",
  "alerts.thwGreaterThanThreshold": "THW je viac ako prahová hodnota {value}{unit}",
  "alerts.thwLessThan": "THW menej ako",
  "alerts.thwLessThanThreshold": "THW je menej ako prahová hodnota {value}{unit}",
  "alerts.triggerHistory": "História upozornenia",
  "alerts.uvGreaterThan": "UV index väčší ako",
  "alerts.uvGreaterThanThreshold": "UV index je vyšší ako prahová hodnota {value}{unit}",
  "alerts.uvLessThan": "UV index nižší ako",
  "alerts.uvLessThanThreshold": "UV index je nižší než prahová hodnota {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Viditeľnosť je väčšia ako prahová hodnota {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Viditeľnosť je nižšia ako prahová hodnota {value}{unit}",
  "alerts.visiblityGreaterThan": "Viditeľnosť väčšia ako",
  "alerts.visiblityLessThan": "Viditeľnosť menšia ako",
  "alerts.whichMeasure": "Na ktoré meranie chcete byť upozornení?",
  "alerts.whichModule": "Na ktorý modul by ste chceli byť upozornení?",
  "alerts.whichSensor": "Na ktorý senzor by ste chceli byť upozornení?",
  "alerts.windChillGreaterThan": "Ochladenie vetra viac ako",
  "alerts.windChillGreaterThanThreshold": "Ochladenie vetra je viac ako prahová hodnota {value}{unit}",
  "alerts.windChillLessThan": "Ochladenie vetra menej ako",
  "alerts.windChillLessThanThreshold": "Ochladenie vetra je menej ako prahová hodnota {value}{unit}",
  "alerts.windSpeedGreaterThan": "Rýchlosť vetra väčšia ako",
  "alerts.windSpeedGreaterThanThreshold": "Rýchlosť vetra je väčšia ako prahová hodnota {value}{unit}",
  "alerts.windSpeedLessThan": "Rýchlosť vetra menšia ako",
  "alerts.windSpeedLessThanThreshold": "Rýchlosť vetra je nižšia ako prahová hodnota {value}{unit}",
  "appUpdate.updateAvailable": "K dispozícii je aktualizácia",
  "appUpdate.updateAvailableOpenAppStore": "Klepnutím otvoríte App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Klepnutím otvoríte Google Play",
  "appUpdate.updateAvailableVersion": "K dispozícii je aktualizácia: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Vyžaduje sa aktualizácia. Navštívte Google Play a aktualizujte aplikáciu na najnovšiu verziu.",
  "appUpdate.upgradeRequiredIos": "Vyžaduje sa aktualizácia. Navštívte App Store a aktualizujte aplikáciu na najnovšiu verziu.",
  "astral.aboveHorizonAllDay": "Celý deň nad obzorom",
  "astral.aboveTheHorizon": "nad obzorom",
  "astral.apparentSize": "Uhlová veľkosť",
  "astral.apparentSizeAcross": "s priemerom {size}",
  "astral.astronomicalDawn": "Astronomický úsvit",
  "astral.astronomicalDusk": "Astronomický súmrak",
  "astral.belowHorizonAllDay": "Celý deň pod obzorom",
  "astral.belowHorizonSince": "Pod obzorom od {time}",
  "astral.belowHorizonSinceOn": "Pod obzorom od {day} {time}",
  "astral.brightAllNight": "Svetlá obloha celú noc — nikdy úplná tma",
  "astral.brightestMoment": "Najsvetlejší okamih",
  "astral.civilDawn": "Občiansky úsvit",
  "astral.civilDusk": "Občiansky súmrak",
  "astral.darkSkyBetween": "Tmavá obloha {from} → {to}",
  "astral.darkSkyWindow": "Tmavá obloha {from} → {to} · {duration} bez Mesiaca",
  "astral.dayLength": "Dĺžka dňa",
  "astral.daylightThroughTheYear": "Dĺžka dňa počas roka",
  "astral.dayOfCycle": "deň {day} z {total}",
  "astral.doesNotOccurToday": "Dnes nenastáva",
  "astral.domeHint": "Ťahaním prejdite nocou",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Najskorší východ slnka",
  "astral.earliestSunset": "Najskorší západ slnka",
  "astral.equinox": "Rovnodennosť",
  "astral.equinoxIn": "Rovnodennosť o {days, plural, one {# deň} few {# dni} many {# dňa} other {# dní}}",
  "astral.evening": "Večer",
  "astral.exactPhaseAt": "Presne o {time}",
  "astral.firstQuarter": "Prvá štvrť",
  "astral.firstSunriseIn": "Prvý východ slnka o {days, plural, one {# deň} few {# dni} many {# dňa} other {# dní}}",
  "astral.firstSunsetIn": "Prvý západ slnka o {days, plural, one {# deň} few {# dni} many {# dňa} other {# dní}}",
  "astral.fullMoon": "Spln",
  "astral.goldenHourBegins": "Začiatok zlatej hodiny",
  "astral.goldenHourEnds": "Koniec zlatej hodiny",
  "astral.highestPoint": "Najvyšší bod",
  "astral.inDays": "o {days, plural, one {# deň} few {# dni} many {# dňa} other {# dní}}",
  "astral.lastQuarter": "Posledná štvrť",
  "astral.latestSunrise": "Najneskorší východ slnka",
  "astral.latestSunset": "Najneskorší západ slnka",
  "astral.litShort": "Osvetl.",
  "astral.longestDay": "Najdlhší deň",
  "astral.lowestPoint": "Najnižší bod",
  "astral.maxAltitudeShort": "Max",
  "astral.midday": "Poludnie",
  "astral.midnightSun": "Polnočné slnko",
  "astral.midnightSunPeriod": "Polnočné slnko",
  "astral.milestoneFootnotePolar": "Slnko tu {days, plural, one {# deň} few {# dni} other {# dní}} v roku nevychádza ani nezapadá, a tak zoznam namiesto obvyklých extrémov východu a západu ukazuje, kedy k tomu dochádza.",
  "astral.milestoneFootnoteTemperate": "Najskorší západ a najneskorší východ nepripadajú na najkratší deň — tieto dva dátumy určuje časová rovnica, nie slnovrat.",
  "astral.moon": "Mesiac",
  "astral.moonAltitude": "Výška",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Vzdialenosť",
  "astral.moonlessFor": "{duration} bez Mesiaca",
  "astral.moonPhases": "Fázy Mesiaca",
  "astral.moonrise": "Východ Mesiaca",
  "astral.moonset": "Západ Mesiaca",
  "astral.moonUpAllNight": "Mesiac je nad obzorom celú noc",
  "astral.moonWashesOutNight": "Mesiac je nad obzorom od {rise} do {set} a presvetľuje celú noc",
  "astral.morning": "Ráno",
  "astral.nauticalDawn": "Nautický úsvit",
  "astral.nauticalDusk": "Nautický súmrak",
  "astral.newMoon": "Nov",
  "astral.nextDay": "+1 deň",
  "astral.nextProperlyDarkNight": "Najbližšia naozaj tmavá noc",
  "astral.nextRise": "najbližší východ o {time}",
  "astral.nextRiseOn": "najbližší východ {day} o {time}",
  "astral.nextSevenNights": "Najbližších sedem nocí",
  "astral.nightDate": "Dátum",
  "astral.noAstronomicalDarknessTonight": "Dnes v noci žiadna astronomická tma",
  "astral.noDarkNightAhead": "Žiadna v najbližších dvoch týždňoch",
  "astral.noStationLocation": "Neznáma poloha",
  "astral.noStationLocationDescription": "Táto stanica nemá uloženú polohu, preto pre ňu nie je možné vypočítať slnko a mesiac.",
  "astral.noSunriseToday": "Dnes slnko nevychádza",
  "astral.nowAtBearing": "teraz {altitude} · azimut {direction}",
  "astral.observing": "Pozorovanie",
  "astral.ofDaylightLeft": "denného svetla zostáva",
  "astral.overTheNextThreeWeeks": "počas najbližších 3 týždňov",
  "astral.percentLit": "osvetlenie {percent}",
  "astral.polarNight": "Polárna noc",
  "astral.polarNightPeriod": "Polárna noc",
  "astral.rightNow": "Práve teraz",
  "astral.riseShort": "Východ",
  "astral.setShort": "Západ",
  "astral.shortestDay": "Najkratší deň",
  "astral.solarNoon": "Pravé poludnie",
  "astral.solstice": "Slnovrat",
  "astral.sunBelowHorizon": "Slnko {degrees}° pod obzorom",
  "astral.sunEvents": "Slnečné udalosti",
  "astral.sunNeverDarkEnough": "Slnko nikdy neklesne 18° pod obzor",
  "astral.sunNeverSets": "Slnko nezapadá",
  "astral.sunrise": "Východ slnka",
  "astral.sunriseAndSunset": "Východ a západ slnka",
  "astral.sunriseAt": "Východ slnka o {time}",
  "astral.sunset": "Západ slnka",
  "astral.sunsetAt": "Západ slnka o {time}",
  "astral.thisYearAtNorth": "Tento rok na {degrees}° s. š.",
  "astral.thisYearAtSouth": "Tento rok na {degrees}° j. š.",
  "astral.tonight": "Dnes v noci",
  "astral.twilightAllNight": "Súmrak celú noc — nikdy úplná tma",
  "astral.upFor": "{duration} nad obzorom",
  "astral.usableLight": "Využiteľné svetlo",
  "astral.vsAverage": "{percent} oproti priemeru",
  "astral.vsYesterday": "oproti včerajšku",
  "astral.waningCrescent": "Cúvajúci kosáčik",
  "astral.waningGibbous": "Cúvajúci Mesiac",
  "astral.waxingCrescent": "Dorastajúci kosáčik",
  "astral.waxingGibbous": "Dorastajúci Mesiac",
  "astral.whereToLook": "Kam sa pozerať",
  "astral.withoutTheMoon": "{duration} bez Mesiaca",
  "auth.alreadyHaveAccount": "Už máte účet?",
  "auth.authContainerTagline": "Váš osobný panel počasia. Pripojte svoje stanice a získajte údaje v reálnom čase na dosah ruky.",
  "auth.backToLogin": "Späť na prihlásenie",
  "auth.checkYourEmail": "Skontrolujte svoj e-mail",
  "auth.continueWithApple": "Pokračovať cez Apple",
  "auth.continueWithFacebook": "Pokračovať cez Facebook",
  "auth.continueWithGoogle": "Pokračovať cez Google",
  "auth.email": "E-mailová adresa",
  "auth.emailRequiredLoginFacebook": "Vyžaduje sa emailové povolenie.",
  "auth.emailVerification": "Overenie e-mailom",
  "auth.emailVerificationFailure": "Vyskytol sa problém s overením vášho emailu.",
  "auth.emailVerificationSuccess": "Váš email bol úspešne overený.",
  "auth.firstName": "Meno",
  "auth.forgotPassword": "Zabudli ste heslo?",
  "auth.forgotPasswordSubtitle": "Zadajte svoj e-mail a pošleme vám odkaz na resetovanie hesla.",
  "auth.lastName": "Priezvisko",
  "auth.login": "Prihlásiť sa",
  "auth.loginSubtitle": "Vitajte späť! Prosím, zadajte svoje údaje.",
  "auth.loginToSmartMixinDescription": "Prihláste sa do SmartMixin a získajte prístup k svojim meteorologickým staniciam, analýzam a osobnému panelu počasia.",
  "auth.logout": "Odhlásiť sa",
  "auth.logoutConfirmation": "Chcete sa odhlásiť?",
  "auth.noAccountYet": "Ešte nemáte účet?",
  "auth.or": "alebo",
  "auth.password": "Heslo",
  "auth.passwordReset": "Resetovanie hesla",
  "auth.passwordResetSuccess": "Vaše heslo bolo úspešne aktualizované.",
  "auth.register": "Vytvoriť účet",
  "auth.registerDescription": "Vytvorte si bezplatný účet SmartMixin na pripojenie vašich meteorologických staníc, sledovanie údajov o počasí a prístup k výkonným analytickým nástrojom.",
  "auth.registerSubtitle": "Vytvorte si účet a začnite.",
  "auth.restorePassword": "Obnoviť heslo",
  "auth.restorePasswordSuccess": "Práve sme vám poslali odkaz na obnovenie hesla na adresu {emailAddress} s ďalšími pokynmi.",
  "auth.sendReset": "Odoslať pokyny na resetovanie",
  "auth.signInWithApple": "Prihlásiť sa cez Apple",
  "auth.socialAccount": "alebo použite svoj účet",
  "auth.staffVerificationCode": "Overovací kód",
  "auth.staffVerificationExpiresIn": "Overené. Platnosť vyprší o {duration}.",
  "auth.staffVerificationInvalidCode": "Nesprávny kód. Skúste to znova.",
  "auth.staffVerificationLoginAsStopped": "Login As bol ukončený: ak chcete pokračovať, zadajte overovací kód na obrazovke Debug.",
  "auth.staffVerificationNotEnrolled": "Pre váš účet nie je nastavená žiadna overovacia aplikácia. Pridajte ju v nastaveniach zabezpečenia v administrácii.",
  "auth.staffVerificationPasskey": "Overiť prístupovým kľúčom",
  "auth.staffVerificationPasskeyExpired": "Platnosť žiadosti o prístupový kľúč vypršala. Skúste to znova.",
  "auth.staffVerificationPasskeyFailed": "Overenie prístupovým kľúčom zlyhalo. Skúste to znova alebo zadajte kód.",
  "auth.staffVerificationPasskeyNotEnrolled": "V tomto telefóne nie je k dispozícii žiadny prístupový kľúč pre váš účet. Pridajte ho z tohto telefónu v nastaveniach zabezpečenia v administrácii alebo zadajte kód.",
  "auth.staffVerificationPasskeySetupLink": "Pridať prístupový kľúč",
  "auth.staffVerificationPasskeyUnavailable": "Prístupové kľúče tu nemožno použiť. Zadajte namiesto toho kód.",
  "auth.staffVerificationPrompt": "Zadajte 6-miestny kód z overovacej aplikácie alebo kód na obnovenie, aby ste mohli používať Login As a vyhľadávanie používateľov.",
  "auth.staffVerificationPromptPasskey": "Použite prístupový kľúč alebo zadajte 6-miestny kód z overovacej aplikácie či kód na obnovenie, aby ste mohli používať Login As a vyhľadávanie používateľov.",
  "auth.staffVerificationSetupLink": "Pridať overovaciu aplikáciu",
  "auth.staffVerificationSubmit": "Overiť",
  "auth.staffVerificationTitle": "Overenie personálu",
  "calendar.afternoon": "Popoludnie",
  "calendar.april": "Apríl",
  "calendar.august": "August",
  "calendar.changePeriod": "Obdobie: {period}. Zmeniť obdobie",
  "calendar.currentDay": "Aktuálny deň",
  "calendar.dateFormat": "Formát dátumu",
  "calendar.day": "Deň",
  "calendar.december": "December",
  "calendar.durationHours": "{hours} h",
  "calendar.durationHoursMinutes": "{hours} h {minutes} min",
  "calendar.durationMinutes": "{minutes} min",
  "calendar.durationMinutesSeconds": "{minutes} min {seconds} s",
  "calendar.durationSeconds": "{seconds} s",
  "calendar.earlierYears": "Skoršie roky",
  "calendar.endTime": "Čas ukončenia",
  "calendar.evening": "Večer",
  "calendar.february": "Február",
  "calendar.goToNextDay": "Nasledujúci deň",
  "calendar.goToNextMonth": "Nasledujúci mesiac",
  "calendar.goToNextWeek": "Nasledujúci týždeň",
  "calendar.goToNextYear": "Nasledujúci rok",
  "calendar.goToPreviousDay": "Predchádzajúci deň",
  "calendar.goToPreviousMonth": "Predchádzajúci mesiac",
  "calendar.goToPreviousWeek": "Predchádzajúci týždeň",
  "calendar.goToPreviousYear": "Predchádzajúci rok",
  "calendar.hour": "Hodina",
  "calendar.hoursCount": "{count, plural, one {# hodina} few {# hodiny} many {# hodiny} other {# hodín}}",
  "calendar.hoursShort": "h",
  "calendar.hoursShortCount": "{count, plural, one {# h} few {# h} many {# h} other {# h}}",
  "calendar.january": "Január",
  "calendar.july": "Júl",
  "calendar.june": "Jún",
  "calendar.last12Hours": "Posledných 12 hodín",
  "calendar.last24Hours": "Posledných 24 hodín",
  "calendar.last30Days": "Posledných 30 dní",
  "calendar.last3Hours": "Posledné 3 hodiny",
  "calendar.last6Hours": "Posledných 6 hodín",
  "calendar.last7Days": "Posledných 7 dní",
  "calendar.lastHour": "Posledná hodina",
  "calendar.laterYears": "Neskoršie roky",
  "calendar.march": "Marec",
  "calendar.max": "Max",
  "calendar.may": "Máj",
  "calendar.month": "Mesiac",
  "calendar.monthTotal": "Celkovo za mesiac",
  "calendar.morning": "Ráno",
  "calendar.nextHours": "Hodinová predpoveď",
  "calendar.night": "Noc",
  "calendar.november": "November",
  "calendar.october": "Október",
  "calendar.oneDay": "1 deň",
  "calendar.oneHour": "1 hodina",
  "calendar.oneMonth": "1 mesiac",
  "calendar.oneWeek": "1 týždeň",
  "calendar.periodRangeSpoken": "{start} až {end}",
  "calendar.previous24Hours": "Predchádzajúcich 24 hodín",
  "calendar.previous30Days": "Predchádzajúcich 30 dní",
  "calendar.previous7Days": "Predchádzajúcich 7 dní",
  "calendar.previousDay": "Predchádzajúci deň",
  "calendar.previousHours": "Predchádzajúce hodiny",
  "calendar.previousMonth": "Predchádzajúci mesiac",
  "calendar.previousWeek": "Predchádzajúci týždeň",
  "calendar.previousYear": "Predchádzajúci rok",
  "calendar.sameDayLastYear": "Ten istý deň minulého roku",
  "calendar.sameMonthLastYear": "Ten istý mesiac minulého roku",
  "calendar.selectADate": "Vyberte dátum",
  "calendar.selectAggregation": "Vyberte zobrazenú hodnotu",
  "calendar.selectAMonth": "Vyberte mesiac",
  "calendar.selectAYear": "Vyberte rok",
  "calendar.selectGranularity": "Vyberte podrobnosť",
  "calendar.selectPeriod": "Vyberte obdobie",
  "calendar.september": "September",
  "calendar.sixHours": "6 hodín",
  "calendar.startTime": "Čas začiatku",
  "calendar.thirtyMinutes": "30 minút",
  "calendar.threeHours": "3 hodiny",
  "calendar.timezone": "Časové pásmo",
  "calendar.today": "Dnes",
  "calendar.untilChanged": "Až do zmeny",
  "calendar.untilTime": "Do {time}",
  "calendar.untilTodayAt": "Dnes do {time}",
  "calendar.untilTomorrowAt": "Zajtra do {time}",
  "calendar.use24HourFormat": "Použiť 24-hodinový formát",
  "calendar.week": "Týždeň",
  "calendar.year": "Rok",
  "calendar.yearToDate": "Od začiatku roka",
  "calendar.yesterday": "Včera",
  "charts.averageOverThePeriod": "Priemer za dané obdobie",
  "charts.calendarView": "Zobrazenie kalendára",
  "charts.charts": "Grafy",
  "charts.chartView": "Zobrazenie grafu",
  "charts.comparison": "Porovnanie",
  "charts.customizeComparisonMetrics": "Prispôsobiť metriky",
  "charts.customizeComparisonMetricsDescription": "Presuňte položky a znovu usporiadajte metriky porovnania. Klepnutím na ikonu oka môžete zobraziť alebo skryť metriky.",
  "charts.loading": "Načítava sa graf",
  "charts.maxOverThePeriod": "Maximum za dané obdobie",
  "charts.measureToDisplay": "Merania na zobrazenie",
  "charts.minMaxRange": "Min. / Max.",
  "charts.noDataForThisPeriod": "Žiadne údaje za toto obdobie",
  "charts.observations": "Pozorovania",
  "charts.observedTemperature": "Nameraná teplota",
  "charts.seriesTableDate": "Dátum",
  "charts.showComparison": "Zobraziť porovnanie",
  "charts.stationComparison": "Porovnanie staníc",
  "charts.stationComparisonDescription": "Porovnajte historické údaje o počasí s inou stanicou",
  "charts.sumOverThePeriod": "Kumulované za dané obdobie",
  "charts.tableLabel": "Tabuľka: {chart}",
  "charts.toggleSeries": "Zobraziť alebo skryť {series}",
  "charts.viewAsChart": "Graf",
  "charts.viewAsList": "Zoznam",
  "charts.viewAsPeriods": "Časti dňa",
  "charts.viewAsTable": "Tabuľka",
  "charts.viewLabel": "Zobrazenie: {chart}",
  "common.add": "Pridať",
  "common.altitude": "Nadmorská výška",
  "common.analysis": "Analýzy",
  "common.average": "Priemer",
  "common.back": "Späť",
  "common.backToHome": "Späť na hlavnú stránku",
  "common.cancel": "Zrušiť",
  "common.cannotBeEmpty": "Toto pole nemôže byť prázdne.",
  "common.close": "Zavrieť",
  "common.dailyForecast": "Denná predpoveď",
  "common.default": "Predvolené",
  "common.delete": "Odstrániť",
  "common.details": "Podrobnosti",
  "common.edit": "Upraviť",
  "common.exitFullscreen": "Ukončiť celú obrazovku",
  "common.forecast": "Predpoveď",
  "common.frequency": "Frekvencia",
  "common.full": "Plná",
  "common.fullscreen": "Celá obrazovka",
  "common.help": "Pomocník",
  "common.hidden": "Skryté",
  "common.high": "Vysoká",
  "common.iDontKnowYet": "Ešte neviem",
  "common.indoor": "Interiér",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Posledná aktualizácia",
  "common.low": "Nízka",
  "common.maximum": "Maximum",
  "common.medium": "Stredná",
  "common.minimum": "Minimum",
  "common.more": "Viac",
  "common.moreInformation": "Viac informácií",
  "common.next": "Ďalej",
  "common.no": "Nie",
  "common.noAccountNeeded": "Bez nutnosti účtu",
  "common.noItemsAvailable": "Nie sú k dispozícii žiadne položky",
  "common.notNow": "Nie teraz",
  "common.now": "Teraz",
  "common.openSettings": "Otvoriť nastavenia",
  "common.outdoor": "Exteriér",
  "common.pageNotFound": "Stránka nenájdená",
  "common.pageNotFoundDescription": "Stránka, ktorú hľadáte, neexistuje alebo bola presunutá.",
  "common.rain": "Dážď",
  "common.reorderCancel": "Presun zrušený: {item}. Späť na pozícii {position} z {count}.",
  "common.reorderEnd": "Umiestnené: {item}. Pozícia {position} z {count}.",
  "common.reorderInstructions": "Ak chcete túto položku presunúť, stlačte medzerník alebo Enter, šípkami nahor a nadol vyberte jej miesto a znova stlačte medzerník alebo Enter na umiestnenie, alebo Escape na zrušenie.",
  "common.reorderOver": "{item} – teraz na pozícii {position} z {count}.",
  "common.reorderStart": "Zdvihnuté: {item}. Pozícia {position} z {count}.",
  "common.share": "Zdieľať",
  "common.shareImageFailed": "Obrázok sa nepodarilo zdieľať",
  "common.shareYourWeather": "Zdieľajte počasie",
  "common.skip": "Preskočiť",
  "common.start": "Štart",
  "common.unknown": "Neznámy",
  "common.validate": "Potvrdiť",
  "common.validEmail": "Vyžaduje sa platná e-mailová adresa.",
  "common.very_low": "Veľmi nízka",
  "common.weatherObservations": "Pozorovania počasia",
  "common.welcome": "Vitajte v SmartMixin!",
  "common.wind": "Vietor",
  "common.yes": "Áno",
  "common.zoomImage": "Priblížiť obrázok",
  "compass.E": "V",
  "compass.E_long": "Východ",
  "compass.ENE": "VSV",
  "compass.ENE_long": "Východ-Severovýchod",
  "compass.ESE": "VJV",
  "compass.ESE_long": "Východ-Juhovýchod",
  "compass.N": "S",
  "compass.N_long": "Sever",
  "compass.NE": "SV",
  "compass.NE_long": "Severovýchod",
  "compass.NNE": "SSV",
  "compass.NNE_long": "Sever-Severovýchod",
  "compass.NNW": "SSZ",
  "compass.NNW_long": "Sever-Severozápad",
  "compass.NW": "SZ",
  "compass.NW_long": "Severozápad",
  "compass.S": "J",
  "compass.S_long": "Juh",
  "compass.SE": "JV",
  "compass.SE_long": "Juhovýchod",
  "compass.SSE": "JJV",
  "compass.SSE_long": "Juh-Juhovýchod",
  "compass.SSW": "JJZ",
  "compass.SSW_long": "Juh-Juhozápad",
  "compass.SW": "JZ",
  "compass.SW_long": "Juhozápad",
  "compass.W": "Z",
  "compass.W_long": "Západ",
  "compass.WNW": "ZSZ",
  "compass.WNW_long": "Západ-Severozápad",
  "compass.WSW": "ZJZ",
  "compass.WSW_long": "Západ-Juhozápad",
  "dashboard.currentObservations": "Aktuálne hodnoty",
  "dashboard.currentRainEvent": "Aktuálna dažďová udalosť",
  "dashboard.currentWeatherConditions": "Aktuálne počasie",
  "dashboard.customizeDashboard": "Prispôsobiť",
  "dashboard.customizeDashboardDescription": "Potiahnutím položiek zmeníte poradie na nástenke. Klepnutím na ikonu oka zobrazíte alebo skryjete sekcie.",
  "dashboard.dashboard": "Panel",
  "dashboard.dayRangeExpected": "{value} očakávané o {time}",
  "dashboard.dayRangeReached": "{value} o {time}",
  "dashboard.dayRangeSteady": "Stabilne {value} celý deň",
  "dashboard.hiddenSensors": "Skryté senzory",
  "dashboard.hideSensor": "Skryť {sensor}",
  "dashboard.lastRainEvent": "Posledná dažďová udalosť",
  "dashboard.lastVisibleSensor": "Aspoň jeden senzor musí zostať viditeľný.",
  "dashboard.manageSensors": "Správa senzorov",
  "dashboard.manageSensorsDescription": "Presuňte položky pre zmenu poradia senzorov. Klepnite na ikonu oka pre zobrazenie alebo skrytie senzorov. Klepnite na názov pre jeho premenovanie.",
  "dashboard.manageSensorsDescriptionWeb": "Kliknutím na ceruzku senzor premenujete, potiahnutím za úchyt zmeníte poradie v zozname a kliknutím na oko ho skryjete alebo zobrazíte.",
  "dashboard.moveSensor": "Presunúť {sensor}",
  "dashboard.pressureSummary": "Súhrn tlaku",
  "dashboard.rainEvents": "Dažďové udalosti",
  "dashboard.rainSummary": "Súhrn zrážok",
  "dashboard.renameSensor": "Premenovať {sensor}",
  "dashboard.shareOutdoorMeasures": "Zdieľajte svoje vonkajšie merania",
  "dashboard.shareOutdoorMeasuresDescription": "Zapojte sa do komunity SmartMixin tým, že zviditeľníte svoje vonkajšie merania pre ostatných. Vnútorné merania nebudú nikdy zdieľané.",
  "dashboard.showSensor": "Zobraziť {sensor}",
  "dashboard.temperatureSummary": "Súhrn teploty",
  "dashboard.useDefaultSensorName": "Použiť predvolený názov",
  "dashboard.windSummary": "Súhrn vetra",
  "devices.batteryLevel": "Úroveň nabitia batérie",
  "devices.firmwareVersion": "Verzia firmvéru",
  "devices.moduleCount": "{count, plural, one {# modul} few {# moduly} many {# modulu} other {# modulov}}",
  "devices.moduleType": "Typ modulu",
  "devices.noNetatmoWeatherStationYet": "Ešte nemáte meteorologickú stanicu Netatmo.",
  "devices.noOutdoorModule": "Pre túto stanicu nie je funkčný vonkajší modul.",
  "devices.notReachable": "Nedostupné",
  "devices.serialNumber": "Sériové číslo",
  "devices.signalAverage": "Stredný",
  "devices.signalBad": "Slabý",
  "devices.signalGood": "Dobrý",
  "devices.signalStrength": "Sila signálu",
  "devices.signalUnknown": "Neznámy",
  "devices.visitNetatmoWebsite": "Navštívte webovú stránku Netatmo",
  "devices.wifiStrength": "Sila Wi-Fi signálu",
  "forecastMaps.addColor": "Pridať farbu",
  "forecastMaps.addLayer": "Pridať vrstvu",
  "forecastMaps.autoDescription": "Najlepší dostupný pre tento pohľad",
  "forecastMaps.autoDescriptionFree": "Bezplatné účty používajú {model}",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.autoSwitched": "Teraz {model}: {previous} pokrýva {coverage, number, percent} tohto pohľadu",
  "forecastMaps.backToMaps": "Späť na mapy",
  "forecastMaps.build": "Vygenerovať",
  "forecastMaps.buildCompleted": "Generovanie dokončené",
  "forecastMaps.builderMetaDescription": "Zostavte si vlastné predpovedné mapy z vrstiev meteorologických modelov.",
  "forecastMaps.builderTitle": "Tvorca máp",
  "forecastMaps.buildFailed": "Generovanie zlyhalo. Skúste to znova.",
  "forecastMaps.buildNotPossible": "Túto mapu zatiaľ nemožno vygenerovať — nie sú k dispozícii žiadne predpovedné dáta.",
  "forecastMaps.buildProgress": "Vykresľovanie… {completed}/{total} krokov",
  "forecastMaps.buildStarting": "Spúšťanie generovania…",
  "forecastMaps.byModel": "Podľa modelu",
  "forecastMaps.byZone": "Podľa zóny",
  "forecastMaps.colormap": "Farebná škála",
  "forecastMaps.colormapCustom": "Vlastné farby",
  "forecastMaps.colormapGroupDomain": "Meteorologické predvoľby",
  "forecastMaps.colormapGroupMatplotlib": "Vedecké predvoľby",
  "forecastMaps.colorStop": "Farba {position}",
  "forecastMaps.configUnavailable": "Táto predpovedná mapa nie je k dispozícii. Namiesto nej sa zobrazuje {name}.",
  "forecastMaps.contourLevels": "Úrovne izolínií",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Francúzsko",
  "forecastMaps.countryGermany": "Nemecko",
  "forecastMaps.countryItaly": "Taliansko",
  "forecastMaps.countryScandinavia": "Škandinávia",
  "forecastMaps.countrySpain": "Španielsko",
  "forecastMaps.countrySwitzerland": "Švajčiarsko",
  "forecastMaps.countryUnitedStates": "Spojené štáty",
  "forecastMaps.coverageUnknown": "Oblasť neznáma",
  "forecastMaps.coversView": "Pokrýva {coverage, number, percent} tohto pohľadu",
  "forecastMaps.customColormapMinColors": "Vlastná farebná škála vyžaduje aspoň dve farby",
  "forecastMaps.customExtent": "Vlastný výrez",
  "forecastMaps.displayName": "Zobrazovaný názov",
  "forecastMaps.downscaling": "Faktor riedenia veterných zástaviek",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Nakresliť oblasť",
  "forecastMaps.east": "Východ",
  "forecastMaps.extentDrawHint": "Ťahaním po mape nakreslite oblasť",
  "forecastMaps.extentInvalid": "Západ musí byť menší než východ a juh menší než sever",
  "forecastMaps.frameTime": "Čas predpovede",
  "forecastMaps.height": "Výška (palce)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.inThisArea": "V tejto oblasti",
  "forecastMaps.invalidHexColor": "Neplatná farba — použite #RRGGBB",
  "forecastMaps.layerHasErrors": "Táto vrstva obsahuje chyby",
  "forecastMaps.layers": "Vrstvy",
  "forecastMaps.layerTypeBarbs": "Veterné zástavky",
  "forecastMaps.layerTypeContour": "Izolínie",
  "forecastMaps.layerTypeFilledContour": "Vyplnené izolínie",
  "forecastMaps.layerTypeMagnitude": "Veľkosť",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vektorové pole",
  "forecastMaps.leave": "Odísť",
  "forecastMaps.levelsCount": "Počet",
  "forecastMaps.levelsInvalid": "Neplatné úrovne izolínií",
  "forecastMaps.levelsModeArange": "Pevný krok",
  "forecastMaps.levelsModeExplicit": "Explicitné hodnoty",
  "forecastMaps.levelsModeLinspace": "Rovnomerne rozložené (počet)",
  "forecastMaps.levelsStep": "Krok",
  "forecastMaps.levelsValues": "Hodnoty",
  "forecastMaps.levelsValuesHint": "Oddelené čiarkami, vzostupne",
  "forecastMaps.loadingMaps": "Načítavajú sa mapy…",
  "forecastMaps.localTimeHint": "Zobrazené v miestnom čase",
  "forecastMaps.lockedConfig": "{model} je model Premium. Namiesto neho sa zobrazuje {fallback}.",
  "forecastMaps.lockedVariable": "{variable}, Premium",
  "forecastMaps.mapDescription": "Popis",
  "forecastMaps.mapName": "Názov mapy",
  "forecastMaps.mapNameRequired": "Zadajte názov",
  "forecastMaps.mapSettings": "Nastavenia mapy",
  "forecastMaps.maxLayersReached": "Táto mapa dosiahla maximum {max} vrstiev.",
  "forecastMaps.maxValue": "Maximálna hodnota",
  "forecastMaps.memoryBudgetExceeded": "Rozlíšenie prekračuje limit vykresľovania — znížte DPI alebo výšku",
  "forecastMaps.memoryBudgetUsage": "Limit vykresľovania: {percent}%",
  "forecastMaps.metaDescription": "Animované predpovedné mapy vytvorené z behov meteorologických modelov.",
  "forecastMaps.metric": "Veličina",
  "forecastMaps.metricRequired": "Vyberte veličinu",
  "forecastMaps.metricUnavailable": "Pre tento model nie je k dispozícii",
  "forecastMaps.minBelowMax": "Minimum musí byť menšie než maximum",
  "forecastMaps.minMaxRequired": "Minimálne a maximálne hodnoty sú pre tento typ vrstvy povinné",
  "forecastMaps.minValue": "Minimálna hodnota",
  "forecastMaps.modelChipAuto": "Auto · {model}",
  "forecastMaps.modelCoversView": "{model} pokrýva {coverage, number, percent} tohto pohľadu",
  "forecastMaps.modelNoRun": "Zatiaľ žiadny dokončený beh",
  "forecastMaps.modelOption": "{model}, {grid}",
  "forecastMaps.moveLayerDown": "Posunúť nadol",
  "forecastMaps.moveLayerUp": "Posunúť nahor",
  "forecastMaps.nanClipToMin": "Obmedziť na minimum",
  "forecastMaps.nanMask": "Maskovať",
  "forecastMaps.nanPolicy": "Chýbajúce dáta",
  "forecastMaps.nanSkip": "Preskočiť",
  "forecastMaps.noCompletedRun": "Táto mapa zatiaľ nebola vytvorená. Skúste to prosím neskôr.",
  "forecastMaps.noLayers": "Zatiaľ žiadne vrstvy. Začnite pridaním vrstvy.",
  "forecastMaps.noMapsAvailable": "Zatiaľ nie sú k dispozícii žiadne predpovedné mapy.",
  "forecastMaps.north": "Sever",
  "forecastMaps.opacity": "Nepriehľadnosť",
  "forecastMaps.openAsAnimation": "Otvoriť ako animáciu",
  "forecastMaps.otherAreas": "Iné oblasti",
  "forecastMaps.outsideArea": "Nepokrýva túto oblasť",
  "forecastMaps.overlayLegend": "Legenda",
  "forecastMaps.pause": "Pozastaviť",
  "forecastMaps.play": "Prehrať",
  "forecastMaps.pointValueAnnouncement": "{value}, {time}",
  "forecastMaps.pointValueError": "Predpoveď pre tento bod sa nepodarilo načítať.",
  "forecastMaps.pointValueLoading": "Načítava sa predpoveď…",
  "forecastMaps.pointValueUnavailable": "Pre tento čas nie sú k dispozícii žiadne údaje.",
  "forecastMaps.premiumModelForView": "{model} pokrýva tento pohľad",
  "forecastMaps.premiumRequired": "Predpovedné mapy vyžadujú Premium",
  "forecastMaps.preview": "Náhľad",
  "forecastMaps.previewEmptyHint": "Na vykreslenie náhľadu nastavte aspoň jednu platnú vrstvu.",
  "forecastMaps.previewFailed": "Náhľad zlyhal",
  "forecastMaps.previewHour": "Hodina predpovede",
  "forecastMaps.previewRendering": "Vykresľovanie náhľadu…",
  "forecastMaps.projection": "Projekcia",
  "forecastMaps.projectionLambertConformal": "Lambertova konformná",
  "forecastMaps.projectionMercator": "Mercatorova",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografická",
  "forecastMaps.regionEurope": "Európa",
  "forecastMaps.regionNorthAmerica": "Severná Amerika",
  "forecastMaps.removeColor": "Odstrániť farbu",
  "forecastMaps.removeLayer": "Odstrániť vrstvu",
  "forecastMaps.retry": "Skúsiť znova",
  "forecastMaps.run": "Beh: {run}",
  "forecastMaps.runNotDisplayable": "Tento beh nemožno zobraziť na interaktívnej mape.",
  "forecastMaps.save": "Uložiť",
  "forecastMaps.selectExtentOnMap": "Vybrať oblasť na mape",
  "forecastMaps.showArea": "Zobraziť oblasť",
  "forecastMaps.showAreaOf": "Zobraziť oblasť, {model}",
  "forecastMaps.south": "Juh",
  "forecastMaps.switchToModel": "Prepnúť na {model}",
  "forecastMaps.title": "Predpovedné mapy",
  "forecastMaps.uMetric": "Zložka U",
  "forecastMaps.unitConversion": "Prevod jednotiek",
  "forecastMaps.unitNone": "Žiadny",
  "forecastMaps.unsavedChangesBody": "Máte neuložené zmeny. Odísť a zahodiť ich?",
  "forecastMaps.unsavedChangesTitle": "Neuložené zmeny",
  "forecastMaps.useCurrentView": "Použiť aktuálne zobrazenie",
  "forecastMaps.useModelDomain": "Vypnuté: použije sa celá oblasť modelu",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Veličiny U a V sa musia líšiť",
  "forecastMaps.valueBetween": "Musí byť medzi {min} a {max}",
  "forecastMaps.variable": "Veličina",
  "forecastMaps.variableMissing": "{variable} nie je k dispozícii",
  "forecastMaps.variableOnlyFrom": "{variable}: poskytuje iba {model}",
  "forecastMaps.viewMap": "Zobraziť mapu",
  "forecastMaps.vMetric": "Zložka V",
  "forecastMaps.west": "Západ",
  "forecastMaps.windAnimation": "Animácia vetra",
  "forecastModels.addForecastModel": "Pridať model",
  "forecastModels.atYourStations": "Dostupné na vašich staniciach",
  "forecastModels.comparisonLoadError": "Porovnanie predpovedných modelov sa nepodarilo načítať",
  "forecastModels.coverageLoading": "Zisťujeme, ktoré z vašich staníc každý model pokrýva…",
  "forecastModels.description_AROME": "Vysokorozlišovací model Météo France umožňujúci riešenie konvekcie nad západnou Európou s rozlíšením 1,3 km. Najlepší vo svojej triede pre krátkodobé predpovede vo Francúzsku; aktualizuje sa každé tri hodiny.",
  "forecastModels.description_ARPEGE_EU": "Európska vnorená oblasť modelu ARPEGE Météo France s rozlíšením 10 km. Strednodobé predpovede nad Európou, aktualizované štyrikrát denne.",
  "forecastModels.description_ARPEGE_GLOBAL": "Globálny numerický model počasia Météo France s rozlíšením 25 km, bežiaci asi 4 dni. Aktualizovaný štyrikrát denne.",
  "forecastModels.description_DMI_DINI": "HARMONIE DINI od DMI: model umožňujúci riešenie konvekcie nad severozápadnou Európou — Dánsko, Benelux, Írsko, Spojené kráľovstvo a Škandinávia — s rozlíšením 2 km bežiaci až 60 hodín, aktualizovaný osemkrát denne. Obsahuje upravené otvorené dáta DMI (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Global Deterministic Prediction System od Environment Canada: svetový strednodobý model s rozlíšením 15 km bežiaci až 10 dní, aktualizovaný dvakrát denne.",
  "forecastModels.description_EC_HRDPS": "High Resolution Deterministic Prediction System od Environment Canada: model umožňujúci riešenie konvekcie nad Kanadou a severnou časťou Spojených štátov s rozlíšením 2,5 km bežiaci až 48 hodín, aktualizovaný štyrikrát denne.",
  "forecastModels.description_EC_RDPS": "Regional Deterministic Prediction System od Environment Canada: strednodobý model nad Severnou Amerikou s rozlíšením 10 km, aktualizovaný štyrikrát denne.",
  "forecastModels.description_ECMWF_HRES": "Vlajková loď medzi modelmi s vysokým rozlíšením (IFS) Európskeho centra pre strednodobé predpovede počasia, všeobecne považovaná za najlepší globálny predpovedný systém na svete. Pokrýva celú planétu v rozlíšení 25 km až na 15 dní, aktualizuje sa štyrikrát denne. Obsahuje upravené otvorené dáta ECMWF (CC BY 4.0).",
  "forecastModels.description_GFS": "Vlajkový strednodobý globálny model NOAA. Pokrýva celú planétu s rozlíšením 25 km až do 16 dní, aktualizovaný štyrikrát denne.",
  "forecastModels.description_HRRR_CONUS": "High-Resolution Rapid Refresh NOAA: model umožňujúci riešenie konvekcie nad kontinentálnymi Spojenými štátmi s rozlíšením 3 km, aktualizovaný každú hodinu. Najvhodnejší pre veľmi krátkodobé predpovede búrok a silných meteorologických javov.",
  "forecastModels.description_ICON": "Globálny model ICON od DWD s rozlíšením 13 km pokrývajúci celú planétu až na 7,5 dňa, aktualizovaný štyrikrát denne. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ICON-2I od ItaliaMeteo, prevádzkovaný spolu s ARPAE: model umožňujúci riešenie konvekcie nad Talianskom s rozlíšením 2,2 km bežiaci až 72 hodín, aktualizovaný dvakrát denne. Obsahuje otvorené dáta ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "Kontrolný beh ICON-CH1-EPS od MeteoSwiss: model umožňujúci riešenie konvekcie nad Alpami s rozlíšením 1 km bežiaci až 33 hodín, aktualizovaný každé tri hodiny.",
  "forecastModels.description_ICON_CH2": "Kontrolný beh ICON-CH2-EPS od MeteoSwiss: model umožňujúci riešenie konvekcie nad Alpami — Švajčiarsko a okolitý alpský región — s rozlíšením 2,1 km bežiaci až 120 hodín, aktualizovaný štyrikrát denne.",
  "forecastModels.description_ICON_DE": "Vysokorozlišovací model DWD umožňujúci riešenie konvekcie nad Nemeckom a susednými krajinami s rozlíšením 2,2 km. Krátkodobé predpovede aktualizované dvakrát denne. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "Európska vnorená oblasť modelu ICON DWD s rozlíšením 7 km pokrývajúca Európu a severný Atlantik. Strednodobé predpovede aktualizované štyrikrát denne. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Otvorená služba predpovede počasia Nórskeho meteorologického ústavu, ktorá kombinuje severské modely s vysokým rozlíšením s údajmi ECMWF a poskytuje celosvetové predpovede až 10 dní dopredu.",
  "forecastModels.description_MF_AROME_ANTILLES": "Vnorená oblasť AROME nad francúzskymi Antilami (Guadeloupe, Martinik) s rozlíšením 2,5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "forecastModels.description_MF_AROME_GUYANE": "Vnorená oblasť AROME nad Francúzskou Guyanou s rozlíšením 2,5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Vnorená oblasť AROME nad Novou Kaledóniou s rozlíšením 2,5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Vnorená oblasť AROME nad Francúzskou Polynéziou s rozlíšením 2,5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Vnorená oblasť AROME nad Réunionom a Mayotte s rozlíšením 2,5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "forecastModels.description_RRFS_CONUS": "Systém Rapid Refresh Forecast od NOAA nad kontinentálnymi USA s rozlíšením 3 km. Hodinové predpovede aktualizované osemkrát denne, do 84 hodín pri štyroch hlavných behoch a 18 hodín pri ostatných.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "Systém Rapid Refresh Forecast od NOAA pokrývajúci celú Severnú Ameriku s rozlíšením 13 km. Hodinové predpovede do 84 hodín, aktualizované štyrikrát denne.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "Vlajková predpoveď SmartMixin. Pre každú hodinu na vašom mieste vyberáme najlepší dostupný model — zvyčajne vysokorozlišovací regionálny model tam, kde existuje (AROME vo Francúzsku, ICON-D2 v Nemecku, HRRR v USA, ARPEGE Europe naprieč kontinentom…) a inde sa vraciame ku globálnemu modelu — potom zaplníme akékoľvek medzery zo susedných zdrojov. Výsledkom je jediná bezproblémová predpoveď pokrývajúca kdekoľvek na svete až 14 dní, automaticky aktualizovaná vždy, keď je niektorý zo základných modelov aktualizovaný.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Vlastná globálna predpoveď Weatherflow, ktorá kombinuje viacero numerických modelov počasia s pozorovaniami zo siete meteorologických staníc Tempest. Celosvetový 10-dňový horizont.",
  "forecastModels.everywhereElse": "Všade inde",
  "forecastModels.everywhereElseFoot": "Použije sa na každej stanici, kam vaše preferované modely nedosiahnu.",
  "forecastModels.everywhereElsePick": "Vyberte jeden",
  "forecastModels.fallbackBlend": "Zmes SmartMixin",
  "forecastModels.fallbackBlendSub": "Kombinuje viacero modelov, každý tam, kde je najsilnejší.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES všade, kam dosiahne.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "Globálny model NOAA. To, čo dnes používa každý účet.",
  "forecastModels.fallbackResolution": "Najvyššie rozlíšenie",
  "forecastModels.fallbackResolutionSub": "Najjemnejšia sieť dostupná na každej stanici.",
  "forecastModels.forecastChipLabelWithRun": "{model}, beh {run}",
  "forecastModels.forecastChipRunHint": "Dlhým stlačením zobrazíte alebo skryjete posledný beh",
  "forecastModels.forecastComparisonDescription": "Ľahko porovnávajte výstupy predpovedného modelu z viacerých zdrojov",
  "forecastModels.forecastFollowingPreferences": "Podľa vašich predvolieb",
  "forecastModels.forecastLoadError": "Predpoveď sa nepodarilo načítať",
  "forecastModels.forecastModel": "Predpovedný model",
  "forecastModels.forecastModelAbout": "O modeli {model}",
  "forecastModels.forecastModelComparison": "Porovnanie predpovedných modelov",
  "forecastModels.forecastModelCoverage": "Pokrytie",
  "forecastModels.forecastModelDescription": "Popis",
  "forecastModels.forecastModels": "Modely predpovede",
  "forecastModels.forecastModelScopeGlobal": "Globálny",
  "forecastModels.forecastModelScopeGlobalDescription": "Tento model pokrýva celú planétu.",
  "forecastModels.forecastModelScopeRegional": "Regionálny",
  "forecastModels.forecastModelScopeRegionalDescription": "Tento model pokrýva iba určitý región.",
  "forecastModels.forecastModelSpecifications": "Špecifikácie",
  "forecastModels.forecastNoPinLocation": "Na toto miesto nedosiahne žiadny preferovaný model — rozhoduje „všade inde“.",
  "forecastModels.forecastNoPinStation": "Na túto stanicu nedosiahne žiadny preferovaný model — rozhoduje „všade inde“.",
  "forecastModels.forecastNoPreferredModels": "Zatiaľ nie sú nastavené žiadne preferované modely.",
  "forecastModels.forecastOverrideElsewhere": "Vaše predvoľby platia všade inde.",
  "forecastModels.forecastPickForLocation": "Alebo vyberte jeden pre toto miesto",
  "forecastModels.forecastPickForStation": "Alebo vyberte jeden pre túto stanicu",
  "forecastModels.forecastPinWinsLocation": "{model} — váš prvý preferovaný model, ktorý dosiahne na toto miesto.",
  "forecastModels.forecastPinWinsStation": "{model} — váš prvý preferovaný model, ktorý dosiahne na túto stanicu.",
  "forecastModels.forecastServedNowHere": "Práve teraz je to tu {model}",
  "forecastModels.forecastSetForLocation": "Nastavené pre toto miesto",
  "forecastModels.forecastSetForStation": "Nastavené pre túto stanicu",
  "forecastModels.forecastSettingsRowSub": "Preferované modely a čo platí všade inde",
  "forecastModels.forecastStopUsingHere": "Tu už nepoužívať",
  "forecastModels.forecastUseForLocation": "Použiť {model} pre toto miesto",
  "forecastModels.forecastUseForStation": "Použiť {model} pre túto stanicu",
  "forecastModels.forecastUsePreferred": "Použiť moje preferované modely",
  "forecastModels.frequencyHourly": "Každú hodinu",
  "forecastModels.horizon": "Horizont",
  "forecastModels.horizonValue": "až do {value} hodín",
  "forecastModels.meshSize": "Veľkosť mriežky",
  "forecastModels.pickerShowAll": "Zobraziť celý katalóg",
  "forecastModels.pickerUnreachable": "{count, plural, one {# ďalší model nedosiahne} few {# ďalšie modely nedosiahnu} many {# ďalších modelov nedosiahne} other {# ďalších modelov nedosiahne}} na žiadnu z vašich staníc",
  "forecastModels.pinInUse": "Používa sa",
  "forecastModels.pinShadowed": "Nikdy sa nepoužije — model vyššie pokrýva všetky vaše stanice",
  "forecastModels.pinSlots": "{used} z {max} · vyberte model",
  "forecastModels.pinSlotsFull": "{max, plural, one {Jediné miesto je obsadené. Odstráňte jeho model, aby ste mohli pridať iný.} few {Všetky # miesta sú obsadené. Jedno odstráňte, aby ste mohli pridať ďalšie.} many {Všetkých # miest je obsadených. Jedno odstráňte, aby ste mohli pridať ďalšie.} other {Všetkých # miest je obsadených. Jedno odstráňte, aby ste mohli pridať ďalšie.}}",
  "forecastModels.pinsUncoveredCount": "{used} z vašich {count, plural, one {# stanice} few {# staníc} many {# staníc} other {# staníc}}: nedosiahne na {used, plural, =1 {ňu} other {ne}} žiadny preferovaný model — rozhoduje „všade inde“.",
  "forecastModels.pinsUncoveredNamed": "{stations}: nedosiahne {count, plural, one {na ňu} other {na ne}} žiadny preferovaný model — rozhoduje „všade inde“.",
  "forecastModels.pinUnreachable": "Nikdy sa nepoužije — nedosiahne na žiadnu z vašich staníc",
  "forecastModels.pinUsedAt": "Používa sa na {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {Používa sa na vašej stanici} few {Používa sa na všetkých # staniciach} many {Používa sa na všetkých # staniciach} other {Používa sa na všetkých # staniciach}}",
  "forecastModels.pinUsedAtSome": "Používa sa na {used} z {count, plural, one {# stanice} few {# staníc} many {# staníc} other {# staníc}}",
  "forecastModels.preferredModels": "Preferované modely",
  "forecastModels.preferredModelsAll": "Jeden zoznam, všetky stanice",
  "forecastModels.preferredModelsOne": "Jeden zoznam, platí všade",
  "forecastModels.publisher": "Vydavateľ",
  "forecastModels.removePreferredModel": "Odstrániť {model} z preferovaných modelov",
  "forecastModels.resetForecastPreference": "Obnoviť predvolené",
  "forecastModels.resetForecastPreferenceHint": "Vymaže preferované modely a vráti predvolené nastavenie SmartMixin.",
  "forecastModels.servedNowMany": "Práve teraz: GFS {count, plural, one {na vašej stanici} few {na všetkých # staniciach} many {na všetkých # staniciach} other {na všetkých # staniciach}}.",
  "forecastModels.servedNowNone": "Práve teraz: GFS všade.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin multimodel",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Predpoveď Weatherflow",
  "forecastModels.weatherForecastModels": "Modely predpovedí počasia",
  "helpCenter.articleCount": "{count, plural, one {# článok} few {# články} many {# článkov} other {# článkov}}",
  "helpCenter.articleNotFound": "Článok nenájdený",
  "helpCenter.articleNotFoundDescription": "Článok, ktorý hľadáte, neexistuje.",
  "helpCenter.backToHelpCenter": "Späť do centra pomoci",
  "helpCenter.browseByCategory": "Prechádzať podľa kategórie",
  "helpCenter.categoryNotFound": "Kategória nenájdená",
  "helpCenter.categoryNotFoundDescription": "Táto kategória neexistuje alebo neobsahuje žiadne články.",
  "helpCenter.contactSupport": "Kontaktovať podporu",
  "helpCenter.feedbackHelpsImprove": "Vaša spätná väzba nám pomáha zlepšovať naše články pomoci.",
  "helpCenter.feedbackReasonNotAnswer": "Neodpovedá na moju otázku",
  "helpCenter.feedbackReasonOutdated": "Informácie sú zastarané",
  "helpCenter.feedbackReasonUnclear": "Pokyny sú nejasné",
  "helpCenter.feedbackWhatWentWrong": "V čom bol problém?",
  "helpCenter.helpCategoryAccount": "Účet",
  "helpCenter.helpCategoryBilling": "Fakturácia",
  "helpCenter.helpCategoryForecast": "Predpovede",
  "helpCenter.helpCategoryGettingStarted": "Začíname",
  "helpCenter.helpCategoryProviders": "Poskytovatelia",
  "helpCenter.helpCategoryStations": "Stanice",
  "helpCenter.helpCategoryTroubleshooting": "Riešenie problémov",
  "helpCenter.helpCenter": "Centrum pomoci",
  "helpCenter.landingDescription": "Nájdite odpovede na časté otázky a zistite, ako čo najlepšie využiť SmartMixin.",
  "helpCenter.linkToSection": "Odkaz na túto sekciu",
  "helpCenter.menuItemDescription": "Často kladené otázky a návody",
  "helpCenter.minRead": "{minutes} min čítania",
  "helpCenter.onThisPage": "Na tejto stránke",
  "helpCenter.platformMobileApp": "Mobilná aplikácia",
  "helpCenter.platformMobileOnly": "Iba v mobilnej aplikácii",
  "helpCenter.platformWebApp": "Webová aplikácia",
  "helpCenter.platformWebOnly": "Iba vo webovej aplikácii",
  "helpCenter.popularArticles": "Obľúbené články",
  "helpCenter.relatedArticles": "Súvisiace články",
  "helpCenter.searchArticles": "Hľadať články...",
  "helpCenter.stillNeedHelp": "Stále potrebujete pomoc?",
  "helpCenter.stillNeedHelpDescription": "Ak tento článok nezodpovedal vašu otázku, rád vám pomôžem osobne.",
  "helpCenter.supportEmailSubject": "Pomoc SmartMixin",
  "helpCenter.supportEmailSubjectTopic": "Pomoc SmartMixin — {topic}",
  "helpCenter.thankYouForFeedback": "Ďakujeme za vašu spätnú väzbu!",
  "helpCenter.wasArticleHelpful": "Bol tento článok užitočný?",
  "intro.locationDescription": "Povoľte prístup k polohe, aby ste získali presné predpovede prispôsobené vašej presnej oblasti — žiadne univerzálne predpovede.",
  "intro.locationTitle": "Predpovede vytvorené pre vás",
  "intro.notificationDescription": "Zapnite upozornenia, aby ste dostávali včasné upozornenia na zmeny počasia, ktoré sú pre vás dôležité — dážď, sneh alebo extrémne podmienky, práve keď to potrebujete vedieť.",
  "intro.notificationsTitle": "Nikdy nezmeškajte zmenu počasia",
  "intro.readyDescription": "Užite si presné predpovede, aktuálne meteorologické informácie a dáta zo staníc po celom svete — všetko v jednej výkonnej aplikácii.",
  "intro.readyTitle": "Ste pripravení!",
  "intro.welcomeDescription": "Získajte hyperlokálne predpovede od popredných meteorologických agentúr — plus prístup k viac ako 40 000 meteorologickým staniciam po celom svete, aby ste videli reálne podmienky, minulé aj súčasné.",
  "intro.welcomeTitle": "Vaše počasie, prepracované",
  "landing.alsoAvailableOn": "K dispozícii aj na:",
  "landing.featureAlertsDescription": "Nastavte si vlastné prahové hodnoty pre akúkoľvek veličinu. Dostanete upozornenie, keď klesne teplota, začne pršať alebo zosilnie vietor.",
  "landing.featureAlertsTitle": "Inteligentné upozornenia",
  "landing.featureAnalyticsDescription": "Interaktívne grafy, analýza trendov a podrobné štatistiky. Ponorte sa do dát o teplote, vlhkosti, tlaku, daždi a vetre.",
  "landing.featureAnalyticsTitle": "Pokročilá analytika",
  "landing.featureExportDescription": "Získajte všetky svoje meteorologické dáta e-mailom ako tabuľku Excel, pripravenú na ďalšiu analýzu v Exceli, Tabuľkách Google alebo vo vašich obľúbených nástrojoch.",
  "landing.featureExportTitle": "Exportujte svoje dáta",
  "landing.featureForecastDescription": "Prístup k {count, plural, one {#+ profesionálnemu predpovednému modelu} few {#+ profesionálnym predpovedným modelom} many {#+ profesionálnym predpovedným modelom} other {#+ profesionálnym predpovedným modelom}} vrátane ECMWF, GFS a regionálnych modelov. Porovnajte ich vedľa seba a urobte si vlastnú predpoveď.",
  "landing.featureForecastTitle": "Porovnajte predpovedné modely",
  "landing.featureHistoryDescription": "Prístup k historickým dátam v hodinovej, dennej a mesačnej mierke. Exportujte ich do Excelu pre výskum alebo osobné archívy.",
  "landing.featureHistoryTitle": "Bohatá história",
  "landing.featureMultiBrandDescription": "Pripojte Netatmo, Davis, Tempest, Ecowitt, Ambient Weather a ďalšie. Už žiadne prepínanie medzi aplikáciami.",
  "landing.featureMultiBrandTitle": "Všetky značky, jedna aplikácia",
  "landing.featuresSubtitle": "SmartMixin vám dáva nástroje, aby ste mohli analyzovať, porovnávať a pochopiť svoje meteorologické dáta ako profesionál.",
  "landing.featuresTitle": "Vytvorené pre milovníkov dát",
  "landing.finalCtaButton": "Vytvoriť účet zadarmo",
  "landing.finalCtaSubtitle": "Pripojte sa k tisícom nadšencov do počasia, ktorí dôverujú SmartMixinu.",
  "landing.finalCtaTitle": "Chcete sa ponoriť hlbšie do svojich meteorologických dát?",
  "landing.heroCta": "Začať zadarmo",
  "landing.heroDescription": "Hĺbková analytika, krásne grafy a profesionálne predpovede — všetky vaše meteorologické stanice zjednotené v jednej výkonnej aplikácii.",
  "landing.heroSecondaryCta": "Preskúmať mapu",
  "landing.heroTagline": "Pre nadšencov do počasia",
  "landing.heroTitle": "Sledujte svoje počasie ako nikdy predtým",
  "landing.pricingComparisonCaption": "Porovnanie funkcií bezplatného plánu a Premium",
  "landing.pricingFeatureAdvancedMetrics": "Pokročilé metriky",
  "landing.pricingFeatureAlerts": "Vlastné upozornenia",
  "landing.pricingFeatureColumn": "Funkcia",
  "landing.pricingFeatureExport": "Export dát (Excel)",
  "landing.pricingFeatureForecastComparison": "Porovnanie predpovedí",
  "landing.pricingFeatureForecasts": "Modely predpovede",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ model} few {#+ modely} many {#+ modelov} other {#+ modelov}}",
  "landing.pricingFeatureReports": "Analýzy a správy",
  "landing.pricingFeatureStationComparison": "Porovnanie staníc",
  "landing.pricingFeatureWidgets": "Widgety domovskej obrazovky",
  "landing.pricingFeatureYearOverYear": "Medziročná analýza",
  "landing.pricingFreeCta": "Začať",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Najobľúbenejší",
  "landing.pricingPremiumCta": "Začať",
  "landing.pricingPremiumDescription": "Od 1,99 €/mesiac — predplaťte si na webe, App Store alebo Google Play",
  "landing.pricingSubtitle": "Začnite zadarmo, upgradujte, keď potrebujete viac.",
  "landing.pricingTitle": "Jednoduchý, transparentný cenník",
  "landing.statBrands": "Podporovaných značiek",
  "landing.statForecasts": "Modelov predpovede",
  "landing.statStations": "Meteorologických staníc",
  "landing.supportedDevicesNote": "Plus viac ako {count, number} verejných staníc zo siete Svetovej meteorologickej organizácie",
  "landing.supportedDevicesSubtitle": "Pripojte svoju existujúcu meteorologickú stanicu za pár minút. Podporujeme {count, plural, one {# hlavnú značku} few {# hlavné značky} many {# hlavných značiek} other {# hlavných značiek}} a pribúdajú ďalšie.",
  "landing.supportedDevicesTitle": "Funguje s vašou stanicou",
  "metrics.absolutePressure": "Absolútny tlak",
  "metrics.airDensity": "Hustota vzduchu",
  "metrics.airGap": "Vzduchová medzera",
  "metrics.apparentTemperature": "Zdanlivá teplota",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Priem.",
  "metrics.avg_wind": "Priemerný vietor",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Teplota čiernej gule",
  "metrics.boilerOn": "Kotol ZAPNUTÝ",
  "metrics.boilerOnInHours": "Kotol ZAPNUTÝ (hodiny)",
  "metrics.cloudCover": "Oblačnosť",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Vodivosť",
  "metrics.dailyPrecipitation": "Denné zrážky",
  "metrics.dailyRain": "Denný dážď",
  "metrics.degreeDayShort": "VD",
  "metrics.depth": "Hĺbka",
  "metrics.depthSensors": "Senzory hĺbky",
  "metrics.dewPoint": "Rosný bod",
  "metrics.distance": "Vzdialenosť",
  "metrics.downTrend": "dole",
  "metrics.ET": "Evapotranspirácia",
  "metrics.etToday": "ET dnes",
  "metrics.feelsLike": "Pocitovo",
  "metrics.feelsLikeWithFormula": "Pocitovo ({formula})",
  "metrics.frostPoint": "Bod mrazu",
  "metrics.gust": "Náraz vetra",
  "metrics.gustDirection": "Smer nárazu vetra",
  "metrics.hail": "Krúpy",
  "metrics.heatIndex": "Tepelný index",
  "metrics.heatingDegreeDays": "Vykurovacie denostupne",
  "metrics.heatingPower": "Výkon vykurovania",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Vlhkosť",
  "metrics.lastLightningImpact": "Posledný úder blesku",
  "metrics.lastMeasure": "Posledné meranie",
  "metrics.leafSensors": "Listové senzory",
  "metrics.leafWetness": "Vlhkosť listov",
  "metrics.lightningDistance": "Vzdialenosť",
  "metrics.lightningStrikeCount": "Počet úderov blesku",
  "metrics.lightningStrikeDistance": "Vzdialenosť úderu blesku",
  "metrics.max": "Max.",
  "metrics.max_gust": "Max. náraz vetra",
  "metrics.maxToday": "Max. dnes",
  "metrics.min": "Min.",
  "metrics.noise": "Hluk",
  "metrics.normalizedHeatingCoefficient": "Normalizovaný koeficient vykurovania",
  "metrics.outdoorTemperature": "Vonkajšia teplota",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2.5",
  "metrics.precipitation": "Zrážky",
  "metrics.pressure": "Tlak",
  "metrics.rain": "Dážď",
  "metrics.rainDurationValue": "Trvanie dažďa: {duration}",
  "metrics.rainfallMeasurement": "Meranie zrážok",
  "metrics.rainRate": "Intenzita dažďa",
  "metrics.relativePressure": "Relatívny tlak",
  "metrics.setPoint": "Požadovaná teplota",
  "metrics.snow": "Sneh",
  "metrics.snowfall": "Sneženie",
  "metrics.soilMoisture": "Vlhkosť",
  "metrics.soilSensors": "Pôdne senzory",
  "metrics.soilWaterTension": "Sací tlak pôdy",
  "metrics.solarEnergy": "Slnečná energia",
  "metrics.solarRadiation": "Slnečné žiarenie",
  "metrics.speed": "Rýchlosť",
  "metrics.stableTrend": "stabilný",
  "metrics.sum": "Súčet",
  "metrics.temperature": "Teplota",
  "metrics.temperatureSensors": "Senzory teploty a vlhkosti",
  "metrics.temperatureShort": "Tepl.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "hore",
  "metrics.uv": "UV",
  "metrics.visibility": "Viditeľnosť",
  "metrics.weatherCondition": "Meteorologické podmienky",
  "metrics.wetBulbGlobeTemperature": "Teplota WBGT",
  "metrics.wetBulbTemperature": "Teplota vlhkého teplomera",
  "metrics.wind": "Vietor",
  "metrics.windChill": "Ochladenie vetra",
  "metrics.windDirection": "Smer vetra",
  "metrics.windMeasurement": "Meranie vetra",
  "metrics.windRun": "Dráha vetra",
  "metrics.windRunDescription": "Dráha vetra je celková vzdialenosť, ktorú vietor prejde za určité časové obdobie",
  "metrics.windSpeed": "Rýchlosť vetra",
  "navigation.allFavorites": "Zobraziť všetky",
  "navigation.breadcrumbs": "Navigačná cesta",
  "navigation.collapseNavigation": "Zbaliť navigáciu",
  "navigation.expandNavigation": "Rozbaliť navigáciu",
  "navigation.main": "Hlavná",
  "navigation.mapShort": "Mapa",
  "navigation.skipToContent": "Preskočiť na hlavný obsah",
  "navigation.stationsShort": "Stanice",
  "network.cancelError": "Požiadavka bola zrušená",
  "network.connectionError": "Server nie je k dispozícii",
  "network.networkError": "Sieť nie je k dispozícii",
  "network.serverError": "Niečo sa pokazilo...",
  "network.timeoutError": "Časový limit pripojenia vypršal",
  "network.unknownError": "Neznáma chyba",
  "premium.alreadyPremium": "Už máte prémiový účet!",
  "premium.bestValue": "Najvýhodnejšie",
  "premium.billingDetailsAndroid": "Bezplatná skúšobná doba: ak ju zrušíte aspoň 24 hodín pred jej koncom, nič vám nebude účtované. Potom sa vaše predplatné SmartMixin automaticky obnovuje, pokiaľ ho nezrušíte aspoň 24 hodín pred koncom aktuálneho obdobia; zrušiť ho môžete kedykoľvek v nastaveniach svojho účtu Google Play. Každé obnovenie sa účtuje za cenu uvedenú na tlačidle vyššie. Platba sa účtuje na váš účet Google Play pri potvrdení nákupu a na začiatku každého obdobia obnovenia.",
  "premium.billingDetailsIos": "Bezplatná skúšobná doba: ak ju zrušíte aspoň 24 hodín pred jej koncom, nič vám nebude účtované. Potom sa vaše predplatné SmartMixin automaticky obnovuje, pokiaľ ho nezrušíte aspoň 24 hodín pred koncom aktuálneho obdobia; zrušiť ho môžete kedykoľvek v nastaveniach svojho účtu App Store. Každé obnovenie sa účtuje za cenu uvedenú na tlačidle vyššie. Platba sa účtuje na váš účet App Store pri potvrdení nákupu a na začiatku každého obdobia obnovenia.",
  "premium.freeBannerBody": "Bezplatné účty dostávajú všade GFS — vaše preferované modely aj „všade inde“ začnú fungovať vo chvíli, keď si predplatíte.",
  "premium.freeBannerTitle": "Predvoľby platia s Premium",
  "premium.freeSubscription": "Bezplatné prémiové predplatné",
  "premium.freeTrialForPeriod": "Bezplatná skúšobná doba na {period, plural, one {# deň} few {# dni} many {# dňa} other {# dní}}",
  "premium.getUnlimitedAccess": "Neobmedzený prístup k:",
  "premium.manageMySubscription": "Spravovať moje predplatné",
  "premium.notPurchasedYet": "Pre tento účet obchodu sa nenašiel žiadny nákup SmartMixin Premium.",
  "premium.orChooseMonthly": "Alebo zvoľte mesačne:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Aktívne",
  "premium.premiumAnnualTrialInfo": "Začnite s bezplatnou skúšobnou dobou na {days, plural, one {# deň} few {# dni} many {# dňa} other {# dní}}",
  "premium.premiumCurrentPlan": "Aktuálny plán",
  "premium.premiumDownloadApp": "Stiahnite si aplikáciu na predplatné:",
  "premium.premiumEndsOn": "Vyprší {date}",
  "premium.premiumFeatureAlerts": "Upozornenia na počasie",
  "premium.premiumFeatureAnalysis": "Pokročilá analýza počasia",
  "premium.premiumFeatureCharts": "Porovnanie grafov",
  "premium.premiumFeatureExport": "Export dát",
  "premium.premiumFeatureForecast": "Regionálne predpovedné modely",
  "premium.premiumFeatureNotification": "Widget stavového riadku",
  "premium.premiumFeatureTitle": "Funkcia Premium",
  "premium.premiumFeatureWidgets": "Widgety domovskej obrazovky",
  "premium.premiumFreePlan": "Zadarmo",
  "premium.premiumInactive": "Bez predplatného",
  "premium.premiumManageStoreSubscription": "Predplatné ste si kúpili cez {store}. Tam ho môžete spravovať alebo zrušiť.",
  "premium.premiumManageWebSubscription": "Spravujte svoje predplatné, aktualizujte spôsob platby alebo zrušte.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Obnovuje sa {date}",
  "premium.premiumSubscribeAnnual": "Ročne — 9,99 €/rok",
  "premium.premiumSubscribedOn": "Predplatené cez {platform}",
  "premium.premiumSubscribedOnWeb": "Predplatené cez web",
  "premium.premiumSubscribeMonthly": "Mesačne — 1,99 €/mesiac",
  "premium.premiumSubscribeOnWeb": "Prihláste sa na odber a odomknite všetky prémiové funkcie.",
  "premium.premiumSubscriptionSuccess": "Vaše predplatné bolo aktivované! Užite si všetky prémiové funkcie.",
  "premium.premiumSubscriptionSuccessTitle": "Vitajte v Premium!",
  "premium.premiumWebappNotice": "Predplatné cez web momentálne nie je k dispozícii.",
  "premium.pricePerMonth": "{price}/mesiac",
  "premium.pricePerYear": "{price}/rok",
  "premium.purchasedNetatmoPro": "V minulosti ste si zakúpili Netatmo Pro ({date}). Poskytuje vám prístup k podmnožine prémiových funkcií. Ak chcete mať prístup ku všetkým prémiovým funkciám, prihláste sa na odber jednej z nasledujúcich ponúk.",
  "premium.purchaseFailed": "Nákup sa nepodarilo dokončiť. Skúste to znova.",
  "premium.restoreFailed": "Nákupy sa nepodarilo obnoviť. Skúste to znova.",
  "premium.restorePurchase": "Obnoviť nákup",
  "premium.savingsPercent": "Ušetríte {percent}%",
  "premium.seePremium": "Zobraziť Premium",
  "premium.startFreeTrial": "Začať bezplatnú skúšobnú verziu",
  "premium.storeUnavailable": "Obchod momentálne nie je dostupný. Skúste to neskôr.",
  "premium.subscribeNow": "Predplatiť teraz — bez skúšobnej doby",
  "premium.switchToPremium": "Prejdite na SmartMixin Premium",
  "premium.thenPrice": "potom {price}",
  "providerHints.ambientWeatherApiKey": "Vytvorené v nastaveniach vášho účtu na ambientweather.net.",
  "providerHints.davisApiSecret": "Zobrazí sa iba raz pri vytvorení V2 API kľúča — uchovajte v bezpečí.",
  "providerHints.davisV2ApiKey": "Zo stránky V2 API kľúčov na weatherlink.com.",
  "providerHints.ecowittApi": "Zo stránky API vášho účtu Ecowitt.",
  "providerHints.ecowittApp": "Kľúč aplikácie, tiež z vášho účtu Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Použite e-mail a heslo vášho účtu My AcuRite — nie prihlásenie do SmartMixin.",
  "providerHints.myAcuriteEmail": "E-mail vášho účtu My AcuRite — nie vaše prihlásenie do SmartMixin.",
  "providerHints.myAcuritePassword": "Heslo vášho účtu My AcuRite.",
  "providerHints.weatherflowToken": "Osobný token z tempestwx.com → nastavenia → autorizácie údajov.",
  "providerHints.wundergroundEditKey": "Použiť iný kľúč",
  "providerHints.wundergroundKey": "Dlhý reťazec zo stránky API kľúčov vášho účtu Weather Underground — nie vaše heslo na wunderground.com.",
  "providerHints.wundergroundKeyExample": "napr. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API kľúč overený",
  "providerHints.wundergroundNoStationsNearby": "V okolí tejto lokality neboli nájdené žiadne stanice. Skúste zadať ID stanice priamo.",
  "providerHints.wundergroundStationIdExample": "napr. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Získajte svoj API kľúč Ambient Weather.",
  "providerIntro.davisStep2": "Získajte svoj V2 API kľúč a API tajomstvo Davis.",
  "providerIntro.ecowittStep2": "Získajte svoj API kľúč a kľúč aplikácie Ecowitt.",
  "providerIntro.getStarted": "Začať",
  "providerIntro.myAcuriteStep2": "Použite e-mail a heslo vášho existujúceho účtu My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "Prihláste sa do Netatmo, keď budete vyzvaní — API kľúč nie je potrebný.",
  "providerIntro.netatmoWeatherStep2": "Prihláste sa do Netatmo, keď budete vyzvaní — API kľúč nie je potrebný.",
  "providerIntro.signupBanner": "Takmer hotovo — vytvorte si bezplatný účet SmartMixin na pripojenie {provider}.",
  "providerIntro.step1": "Prihláste sa do svojho účtu SmartMixin (NIE do {provider}).",
  "providerIntro.step3EmailPassword": "Zadajte sem.",
  "providerIntro.step3KeyOrToken": "Vložte sem.",
  "providerIntro.step3OAuth": "Autorizujte SmartMixin vo vyskakovacom okne.",
  "providerIntro.step3Wunderground": "Vložte svoj API kľúč a potom vyberte stanicu v okolí alebo zadajte ľubovoľné ID stanice.",
  "providerIntro.stepOfTotal": "Krok {step} z {total}",
  "providerIntro.title": "Pripojiť {provider}",
  "providerIntro.weatherflowStep2": "Získajte svoj osobný Tempest token.",
  "providerIntro.wundergroundBrowsePublic": "Nemáte stanicu? Prehliadajte verejné",
  "providerIntro.wundergroundFindNearby": "Nájsť stanice v okolí",
  "providerIntro.wundergroundOrEnterId": "Alebo zadať ID stanice",
  "providerIntro.wundergroundStep2": "Získajte svoj API kľúč Weather Underground. Potom budete môcť pripojiť akúkoľvek stanicu — vlastnú alebo verejnú.",
  "reports.agroMeteorology": "Agrometeorológia",
  "reports.analysis": "Analýzy",
  "reports.annualCumulativeRainfallComparison": "Ročné kumulatívne porovnanie zrážok",
  "reports.annualHeatingDurationComparison": "Porovnanie doby vykurovania za rok",
  "reports.annualHeatingEfficiency": "Ročná efektivita vykurovania",
  "reports.annualIndoorComparison": "Ročné porovnanie - interiér",
  "reports.annualOutdoorComparison": "Ročné porovnanie - exteriér",
  "reports.annualOutdoorReport": "Výročná správa - exteriér",
  "reports.annualReport": "Výročná správa",
  "reports.annualSolarReport": "Výročná solárna správa",
  "reports.annualWaterBalance": "Ročná vodná bilancia",
  "reports.annualWaterBalanceCarryOver": "Preniesť z roku {year} ({value})",
  "reports.annualWaterBalanceDescription": "Vodná bilancia (zjednodušená verzia, používa sa len dážď a evapotranspirácia) pomáha riadiť zásobovanie vodou",
  "reports.avgHumidity": "Priemerná vlhkosť",
  "reports.avgMaxTemperature": "Priemerná T°max",
  "reports.avgMetric": "Priemer – {metric}",
  "reports.avgMinTemperature": "Priemerná T°min",
  "reports.avgPressure": "Priemerný tlak",
  "reports.avgTemperature": "Priemerná teplota",
  "reports.chartsAndTable": "Grafy a tabuľka",
  "reports.climateNormalPeriodOfRecord": "Obdobie merania ({years, plural, one {# rok} few {# roky} many {# roka} other {# rokov}})",
  "reports.climateNormals": "Klimatické normály",
  "reports.climateNormalStandardLabel": "Štandardný normál ({period})",
  "reports.climateTrendPerDecade": "Trend teploty: {value} za desaťročie počas {years, plural, one {# roka} few {# rokov} many {# rokov} other {# rokov}}",
  "reports.coldestMonthRanking": "Najchladnejší {month} v histórii meraní",
  "reports.comfortable": "Komfortné (45 % {lessThan} vlhkosť ≤ 60 %)",
  "reports.cumulativeRainfall": "Kumulatívne zrážky",
  "reports.cumulativeRainfallDescription": "Sledujte celkové zrážky nahromadené za zvolené obdobie.",
  "reports.dailyMaxRainfall": "Max. denné zrážky",
  "reports.dataExport": "Export údajov",
  "reports.dataExportXlsxFormatDescription": "Exportujte všetky údaje vašej stanice vo formáte Excel (*.xlsx). Po kliknutí na tlačidlo vám po niekoľkých minútach príde email so spracovanými údajmi.",
  "reports.daysOfData": "{days, plural, one {# deň} few {# dni} many {# dňa} other {# dní}} údajov",
  "reports.daysWithFrost": "Mrazivé dni",
  "reports.daysWithHeavyRain": "Dni s výdatným dažďom (≥ {threshold})",
  "reports.daysWithoutThaw": "Dni bez odmäku",
  "reports.daysWithStrongFrost": "Dni so silným mrazom",
  "reports.emailSent": "E-mail bol odoslaný do vašej poštovej schránky",
  "reports.frostDays": "Mrazové dni",
  "reports.grasslandTemperatureSum": "Súčet teploty trávnatých plôch",
  "reports.grasslandTemperatureSumDescription": "Ak sa na jar prekročí súčet {threshold}, dosiahol sa udržateľný začiatok vegetácie (funguje v Európe)",
  "reports.growingDegreeDays": "Rastové stupňodni",
  "reports.highPressure": "Tlaková výš (priemerný tlak ≥ {threshold})",
  "reports.iceDays": "Ľadové dni",
  "reports.indoorReport": "Správa o interiéri",
  "reports.keyFacts": "Kľúčové fakty",
  "reports.longestDrySpell": "Najdlhšie suché obdobie",
  "reports.longestRunOfRainyDays": "Najdlhší priebeh daždivých dní",
  "reports.longestRunWithoutRun": "Najdlhší priebeh dní bez dažďa",
  "reports.longestWetSpell": "Najdlhšie daždivé obdobie",
  "reports.lowPressure": "Tlaková níž (priemerný tlak {lessThan} {threshold})",
  "reports.maxHumidity": "Maximálna vlhkosť",
  "reports.maxMetric": "Maximum – {metric}",
  "reports.maxPressure": "Maximálny tlak",
  "reports.maxTemperature": "Maximálna teplota",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maximálna amplitúda (/24 h)",
  "reports.minHumidity": "Minimálna vlhkosť",
  "reports.minMetric": "Minimum – {metric}",
  "reports.minPressure": "Minimálny tlak",
  "reports.minTemperature": "Minimálna teplota",
  "reports.minTempMagnitude24h": "Minimálna amplitúda (/24 h)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Ešte # deň} few {Ešte # dni} many {Ešte # dňa} other {Ešte # dní}} tento mesiac",
  "reports.monthlyAverageCountdownDetail": "Potom sa zobrazí priemer tohto mesiaca a jeho poradie.",
  "reports.monthlyAverageRule": "Mesačné priemery a poradia sa zobrazia, keď kalendárny mesiac má zaznamenaných {days, plural, one {# deň} few {# dni} many {# dňa} other {# dní}}.",
  "reports.monthlyHeatingEfficiency": "Mesačná efektivita vykurovania",
  "reports.monthlyOutdoorReport": "Mesačná správa exteriér",
  "reports.monthlyReport": "Mesačná správa",
  "reports.monthlySolarReport": "Mesačná solárna správa",
  "reports.monthlyWindReport": "Mesačná správa o vetre",
  "reports.monthsOfData": "{months, plural, one {# mesiac} few {# mesiace} many {# mesiaca} other {# mesiacov}} údajov",
  "reports.numberOfDays": "Počet dní",
  "reports.onThisDayChartRule": "Graf po rokoch sa zobrazí, keď bude pre {date} zaznamenaných {count, plural, one {# rok} few {# roky} many {# roka} other {# rokov}}.",
  "reports.onThisDayChartSummary": "{years, plural, one {# rok} few {# roky} many {# roka} other {# rokov}} s teplotou, {first} až {last}. Rekordné maximum {high} ({highYears}), rekordné minimum {low} ({lowYear}). Normálny deň {min} až {max}.",
  "reports.onThisDayCoverage": "{years, plural, one {# rok od {firstYear}} few {# roky od {firstYear}} many {# roka od {firstYear}} other {# rokov od {firstYear}}}",
  "reports.onThisDayDataSince": "Táto stanica má údaje od {date}.",
  "reports.onThisDayEveryYear": "Každý {date} v archíve",
  "reports.onThisDayGapNoData": "žiadne údaje",
  "reports.onThisDayInHistory": "V tento deň v histórii",
  "reports.onThisDayLeaveOk": "Túto obrazovku môžete opustiť; načítavanie pokračuje.",
  "reports.onThisDayLoadFailed": "{date} sa nepodarilo načítať. Skontrolujte pripojenie a skúste to znova.",
  "reports.onThisDayNoDataRun": "{start}–{end} · žiadne údaje ({count, plural, one {# rok} few {# roky} many {# roka} other {# rokov}})",
  "reports.onThisDayNormal": "Normálny deň: {min} až {max}",
  "reports.onThisDayNoYears": "Zatiaľ žiadny úplný {date} v archíve",
  "reports.onThisDayNoYearsDetail": "Táto stránka sa zaplní od prvého {date}, ktorý stanica zaznamená celý.",
  "reports.onThisDayNoYearSelected": "Nie je vybraný žiadny rok",
  "reports.onThisDayOneReading": "1 meranie",
  "reports.onThisDayOneReadingSummary": "{year}: {value}, 1 meranie, zrážky {rain}",
  "reports.onThisDayOpenRecords": "Otvoriť Rekordy a klíma",
  "reports.onThisDayPickHint": "Zmení zobrazený deň",
  "reports.onThisDayPickTitle": "Vyberte deň",
  "reports.onThisDayRain": "Zrážky {date}",
  "reports.onThisDayRainNotMeasured": "nemerané",
  "reports.onThisDayRainOnlySummary": "{year}: zrážky {rain}",
  "reports.onThisDayRainSince": "zrážky od {year}",
  "reports.onThisDayRainSummary": "Zrážky {date}. Najdaždivejší deň {value} ({years}).",
  "reports.onThisDayRetry": "Skúsiť znova",
  "reports.onThisDaySingleReading": "Roky s jediným meraním v tento deň ({count}) nie sú v grafe zobrazené.",
  "reports.onThisDaySlowLoad": "Načítava sa {years, plural, one {# rok} few {# roky} many {# roka} other {# rokov}} pre {date}. Prvé zobrazenie dátumu môže trvať až 20 sekúnd.",
  "reports.onThisDaySlowLoadGeneric": "Načítava sa história tejto stanice pre {date}. Prvé zobrazenie dátumu môže trvať až 20 sekúnd.",
  "reports.onThisDayTied": "rovnako ako {years}",
  "reports.onThisDayTiedMore": "rovnako ako {years} +{count}",
  "reports.onThisDayYearSummary": "{year}: minimum {min}, maximum {max}, zrážky {rain}",
  "reports.onThisDayYearTied": "{year} ({tied})",
  "reports.outdoorReport": "Správa o exteriéri",
  "reports.overviewSection": "Prehľad",
  "reports.rainfall": "Zrážky",
  "reports.rainyDays": "Daždivé dni",
  "reports.recordClimatologicalDay": "Klimatologický deň (06–06 UTC)",
  "reports.recordClimDayBody": "Zrážky sa tu sčítavajú po kalendárnych dňoch, od polnoci do polnoci miestneho času stanice. Meteorologické služby ich sčítavajú od 06:00 do 06:00 UTC, takže búrka okolo polnoci môže z iného dňa urobiť ten najdaždivejší.",
  "reports.recordDailyRain": "Najdaždivejší deň",
  "reports.recordFromHourlyReadings": "Z hodinových meraní",
  "reports.recordHigh": "Rekordné maximum",
  "reports.recordLow": "Rekordné minimum",
  "reports.recordOfficialBody": "Meteorologická služba zverejňuje pre túto stanicu denné maximum a minimum odčítané z maximálneho a minimálneho teplomera. Zachytia krátke špičky, ktoré hodinové merania nezaznamenajú, preto nahrádzajú hodnoty vypočítané z hodinových meraní.",
  "reports.recordOfficialValue": "Oficiálna hodnota",
  "reports.recordsAndClimatology": "Rekordy a klíma",
  "reports.recordSheetTitle": "O týchto rekordoch",
  "reports.recordsSince": "Rekordy od {date}",
  "reports.recordWindGust": "Najsilnejší náraz vetra",
  "reports.relativelyWet": "Pomerne vlhké (60 % {lessThan} Vlhkosť ≤ 80 %)",
  "reports.sectionReportCount": "{count, plural, one {# správa} few {# správy} many {# správ} other {# správ}}",
  "reports.sendEmail": "Odoslať email",
  "reports.summerDays": "Letné dni",
  "reports.tableScrollRegion": "{title}, posúva sa vodorovne",
  "reports.tooDry": "Príliš suché (Vlhkosť ≤ 45%)",
  "reports.tooWet": "Príliš vlhké (Vlhkosť {greaterThan} 80 %)",
  "reports.tropicalNights": "Tropické noci",
  "reports.unlockPremiumSubtitle": "Súčasť SmartMixin Premium",
  "reports.unlockPremiumTitle": "Odomknite {count, plural, one {# prémiovú funkciu} few {# prémiové funkcie} many {# prémiových funkcií} other {# prémiových funkcií}}",
  "reports.warmestMonthRanking": "Najteplejší {month} v histórii meraní",
  "reports.waterBalance": "Vodná bilancia",
  "reports.yearsOfData": "{years, plural, one {# rok} few {# roky} many {# roka} other {# rokov}} údajov",
  "reports.yearToDateTemperatureComparison": "Porovnanie teplôt od začiatku roka",
  "sensors.bgtSensors": "Čierna guľa a WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareHumidity": "Porovnať vlhkosť",
  "sensors.compareMoisture": "Porovnať vlhkosť pôdy",
  "sensors.comparePm25": "Porovnať PM2.5",
  "sensors.compareTemperatures": "Porovnať teploty",
  "sensors.compareWaterTension": "Porovnať sací tlak pôdy",
  "sensors.depthByChannel": "Hĺbka podľa kanála",
  "sensors.heatStressExtreme": "Extrémny tepelný stres",
  "sensors.heatStressModerate": "Mierny tepelný stres",
  "sensors.heatStressNone": "Žiadny tepelný stres",
  "sensors.heatStressStrong": "Silný tepelný stres",
  "sensors.heatStressVeryStrong": "Veľmi silný tepelný stres",
  "sensors.indoorClimate": "Vnútorná klíma",
  "sensors.indoorCo2Levels": "Úrovne CO2",
  "sensors.indoorTemperatureAndHumidity": "Teplota a vlhkosť",
  "sensors.leafWetnessByChannel": "Vlhkosť listov podľa kanálu",
  "sensors.lightningSensor": "Blesk",
  "sensors.moistureByChannel": "Vlhkosť pôdy podľa kanálu",
  "sensors.noDataAvailable": "Žiadne dáta nie sú k dispozícii",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 podľa kanálu",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Vyberte kanál",
  "sensors.sensorDetailDescription": "Zobrazenie historických údajov a trendov pre kanály senzora.",
  "sensors.sensorHistory": "História senzora",
  "sensors.soilConductivityByChannel": "Vodivosť podľa kanálu",
  "sensors.soilTemperatureByChannel": "Teplota pôdy podľa kanálu",
  "sensors.strikesToday": "Údery dnes",
  "sensors.temperatureByChannel": "Teplota podľa kanálu",
  "sensors.viewChart": "Zobraziť graf",
  "sensors.waterTensionByChannel": "Sací tlak pôdy podľa kanálu",
  "settings.appearance": "Vzhľad",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arabčina",
  "settings.bulgarian": "bulharčina",
  "settings.catalan": "katalánčina",
  "settings.chartGestures": "Gestá na grafoch",
  "settings.chartGesturesDescription": "Potiahnutím po grafoch sa zmení časové obdobie, stiahnutím grafov sa zmení časový rozsah",
  "settings.choiceCount": "{count, plural, one {Dostupný: #} few {Dostupné: #} many {Dostupných: #} other {Dostupných: #}}",
  "settings.contactUs": "Kontaktujte nás",
  "settings.contactUsDescription": "Získajte pomoc alebo pošlite spätnú väzbu",
  "settings.croatian": "chorvátčina",
  "settings.czech": "čeština",
  "settings.dailyDetailByPeriods": "Denné podrobnosti podľa častí dňa",
  "settings.dailyDetailByPeriodsDescription": "Zoskupí 24 hodín do noci, rána, popoludnia a večera — rovnaké rozdelenie, aké používa denný súhrn.",
  "settings.danish": "dánčina",
  "settings.dark": "Tmavá téma",
  "settings.dataDisplay": "Zobrazenie údajov",
  "settings.dateAndTime": "Dátum a čas",
  "settings.donateButton": "Prispieť darom",
  "settings.donateDescription": "SmartMixin vyvíja malý tím. Ak je pre vás užitočný, môžete podporiť jeho vývoj jednorazovým darom v ľubovoľnej výške. Je to dar — nemení váš plán ani neodomyká žiadne funkcie.",
  "settings.donateSuccessBody": "Váš dar pomáha udržať SmartMixin v prevádzke a zlepšovať ho. Veľmi si to vážime.",
  "settings.donateSuccessTitle": "Ďakujeme za vašu podporu!",
  "settings.donateTitle": "Podporte SmartMixin",
  "settings.dragToReorder": "Presunutím zmeníte poradie",
  "settings.dutch": "holandčina",
  "settings.english": "angličtina",
  "settings.french": "francúzština",
  "settings.german": "nemčina",
  "settings.gestures": "Gestá",
  "settings.greek": "gréčtina",
  "settings.hungarian": "maďarčina",
  "settings.italian": "taliančina",
  "settings.japanese": "japončina",
  "settings.korean": "kórejčina",
  "settings.language": "Jazyk",
  "settings.languageDescription": "Preferovaný jazyk",
  "settings.light": "Svetlá téma",
  "settings.mapTheme": "Motív mapy",
  "settings.mapThemeAuto": "Auto",
  "settings.mapThemeDark": "Tmavá",
  "settings.mapThemeDescription": "Pri voľbe Auto sa mapa riadi motívom aplikácie.",
  "settings.mapThemeLight": "Svetlá",
  "settings.measurementUnits": "Merné jednotky",
  "settings.netatmoDashboard": "Prehľad Netatmo",
  "settings.netatmoLayoutCards": "Zoznam kariet",
  "settings.netatmoLayoutCardsDescription": "Jedna karta na modul, všetko v jednom posúvaní",
  "settings.netatmoLayoutClassic": "Klasické",
  "settings.netatmoLayoutClassicDescription": "Dve karty, prepínanie medzi modulmi",
  "settings.netatmoNewLayoutNotice": "Nové rozloženie prehľadu: jedna karta na modul.",
  "settings.netatmoSwitchBackToClassic": "Späť na klasické",
  "settings.netatmoSwitchToLayout": "Prepnúť na {layout}",
  "settings.norwegian": "nórčina",
  "settings.notificationsSection": "Oznámenia",
  "settings.ongoingNotificationEnabled": "Povoliť trvalé oznámenie",
  "settings.ongoingNotificationMetrics": "Zobrazené metriky",
  "settings.ongoingNotificationPermissionRequired": "Vyžaduje sa povolenie na oznámenia",
  "settings.ongoingNotificationPreviewHint": "Náhľad — zapnite widget, aby sa zobrazil",
  "settings.ongoingNotificationStatusBar": "Stavový riadok",
  "settings.polish": "poľština",
  "settings.portuguese": "portugalčina",
  "settings.preferencesSection": "Predvoľby",
  "settings.privacyPolicy": "Zásady ochrany osobných údajov",
  "settings.russian": "ruština",
  "settings.serbian": "srbčina",
  "settings.settings": "Nastavenia",
  "settings.settingsPageTitle": "Nastavenia - {page}",
  "settings.slovak": "slovenčina",
  "settings.smallDecimals": "Malé desatinné",
  "settings.smallDecimalsDescription": "Zobraziť desatinné číslice v menšej veľkosti",
  "settings.spanish": "španielčina",
  "settings.statusBarWidget": "Widget stavového riadku",
  "settings.statusBarWidgetDescription": "Vždy viditeľné údaje o počasí",
  "settings.subscriptionSection": "Predplatné",
  "settings.supportSection": "Podpora",
  "settings.swedish": "švédčina",
  "settings.systemTheme": "Systémová téma",
  "settings.termsOfService": "Podmienky poskytovania služby",
  "settings.themeDarkShort": "Tmavá",
  "settings.themeLightShort": "Svetlá",
  "settings.themeSystemShort": "Systém",
  "settings.turkish": "turečtina",
  "settings.ukrainian": "ukrajinčina",
  "settings.units": "Jednotky",
  "settings.unitsDescription": "Merné jednotky zobrazené v rámci aplikácie",
  "settings.update": "Aktualizovať",
  "settings.windDirectionConvention": "Šípka smeru vetra",
  "settings.windDirectionConventionDescription": "Vyberte spôsob zobrazenia šípok smeru vetra",
  "settings.windDirectionMeteorological": "Smer pôvodu",
  "settings.windDirectionMeteorologicalDescription": "Šípka ukazuje, odkiaľ vietor fúka (meteorologická konvencia)",
  "settings.windDirectionOceanographic": "Smer prúdenia",
  "settings.windDirectionOceanographicDescription": "Šípka ukazuje, kam vietor fúka (oceánografická konvencia)",
  "stations.addAStation": "Pridať stanicu",
  "stations.addToFavorites": "Pridať k obľúbeným",
  "stations.addYourOwnStation": "Pridajte vlastnú stanicu",
  "stations.clearRecentLocations": "Vyčistiť",
  "stations.clearSearch": "Vymazať hľadanie",
  "stations.currentLocation": "Súčasná lokalita",
  "stations.customizedStationName": "Vlastný názov stanice",
  "stations.favoriteLocations": "Obľúbené",
  "stations.favoriteLocationsEmpty": "Môžete pridať až 5 obľúbených miest.",
  "stations.favoriteStations": "Obľúbené stanice",
  "stations.filterStationDescription": "Nezobrazujte stanice s nespoľahlivými meraniami",
  "stations.filterStations": "Filtrovať stanice",
  "stations.filterStationSourceDescription": "Vyberte poskytovateľov staníc, ktorých chcete zobraziť na mape",
  "stations.findStationsNearYou": "Nájsť stanice vo vašom okolí",
  "stations.hiddenStations": "Skryté stanice",
  "stations.hiddenStationsDescription": "Stanicu môžete znova zobraziť klepnutím na ikonu oka vedľa nej.",
  "stations.hideStationNamed": "Skryť {station}",
  "stations.lastSeen": "naposledy {time}",
  "stations.loadingStation": "Načítava sa stanica…",
  "stations.location": "Miesto",
  "stations.locationAddedToFavorites": "Poloha pridaná do obľúbených položiek",
  "stations.locationNotGranted": "Povolenie na umiestnenie nie je udelené. Umožnite prístup k vašej polohe v nastaveniach zariadenia.",
  "stations.locationRemovedFromFavorites": "Poloha odstránená z obľúbených položiek",
  "stations.locations": "Miesta",
  "stations.locationUnavailable": "Nepodarilo sa zistiť vašu polohu. Skontrolujte nastavenia zariadenia.",
  "stations.maxFavoriteLocationsReached": "Môžete mať najviac 5 obľúbených miest. Odstráňte jedno, aby ste mohli pridať ďalšie.",
  "stations.modifyFavoriteStations": "Upraviť obľúbené stanice",
  "stations.modifyFavoriteStationsDescription": "Poradie obľúbených staníc môžete zmeniť ich pretiahnutím. Môžete ich tiež odstrániť zo zoznamu.",
  "stations.myLocation": "Moja poloha",
  "stations.nearbyWeatherStations": "Blízke meteorologické stanice",
  "stations.noLocationsFound": "Žiadne miesta nenájdené",
  "stations.noLongerReported": "Už nie je v zozname",
  "stations.noLongerReportedBy": "{provider}: nie je v zozname od {date}",
  "stations.noSearchResults": "Vášmu vyhľadávaniu nezodpovedajú žiadne články",
  "stations.noStationsFound": "Žiadne stanice nenájdené",
  "stations.noWeatherStationYet": "Ešte nemáte meteorologickú stanicu.",
  "stations.recentLocations": "Nedávne",
  "stations.recentLocationsEmpty": "Vaša nedávna história je prázdna.",
  "stations.removeFromFavorites": "Odstrániť z obľúbených",
  "stations.removeStationNamed": "Odstrániť {station} z obľúbených",
  "stations.reorderStationNamed": "Presunúť {station}",
  "stations.searchForLocation": "Vyhľadajte miesto",
  "stations.searchForWeatherStation": "Vyhľadajte meteorologickú stanicu",
  "stations.searchResults": "Výsledky vyhľadávania",
  "stations.searchResultsEmpty": "Nezistili sa žiadne výsledky.",
  "stations.searchResultsFound": "{count, plural, one {Nájdený # výsledok} few {Nájdené # výsledky} many {Nájdené # výsledku} other {Nájdených # výsledkov}}",
  "stations.searchStationsDescription": "Zadajte mesto, adresu alebo názov miesta pre nájdenie meteorologických staníc v okolí.",
  "stations.searchStationsHint": "Použite vyhľadávacie pole vyššie na objavenie meteorologických staníc kdekoľvek na svete.",
  "stations.selectStationForComparison": "Vyberte stanicu na porovnanie",
  "stations.stationAddedToFavorites": "Stanica bola pridaná medzi obľúbené",
  "stations.stationCount": "{count, plural, one {# stanica} few {# stanice} many {# stanice} other {# staníc}}",
  "stations.stationInformation": "Informácie o stanici",
  "stations.stationName": "Názov stanice",
  "stations.stationObservationsDescription": "Zobrazte najnovšie pozorovania z meteorologických staníc",
  "stations.stationRemovedFromFavorites": "Stanica bola odstránená z obľúbených",
  "stations.stationsLoading": "Načítavajú sa meteorologické stanice",
  "stations.stationsNear": "Stanice v okolí: {place}",
  "stations.stationType": "Typ stanice",
  "stations.statusOffline": "Offline",
  "stations.statusOnline": "Online",
  "stations.statusStale": "Zastarané",
  "stations.tryAnotherLocation": "Nepodarilo sa nám nájsť žiadne meteorologické stanice v blízkosti tohto miesta. Skúste hľadať v inej oblasti.",
  "stations.unhideStationNamed": "Znova zobraziť {station}",
  "stations.weatherStation": "Meteorologická stanica",
  "stations.weatherStationCount": "{count, plural, one {# meteorologická stanica} few {# meteorologické stanice} many {# meteorologickej stanice} other {# meteorologických staníc}}",
  "stations.weatherStations": "Meteorologické stanice",
  "stations.welcomeConnectService": "Vlastníte meteostanicu? Pripojte svoju službu",
  "stations.welcomeSubtitle": "Vaše počasie, všetko na jednom mieste",
  "thermostat.away": "Preč",
  "thermostat.boilerOn": "Kotol ZAPNUTÝ",
  "thermostat.hg": "Ochrana pred mrazom",
  "thermostat.homeInformation": "Informácie o domácnosti",
  "thermostat.homeName": "Názov domova",
  "thermostat.manualBoost": "Manuálne zvýšenie",
  "thermostat.manualSetpointUntil": "Manuálna nastavená hodnota do",
  "thermostat.noThermostatYet": "Ešte nemáte termostat.",
  "thermostat.relay": "Relé",
  "thermostat.room": "Miestnosť",
  "thermostat.rooms": "Miestnosti",
  "thermostat.smartThermostat": "Inteligentný termostat",
  "thermostat.smartValve": "Inteligentný ventil",
  "thermostat.whenBackHome": "Kedy sa vrátite domov?",
  "units.celsius": "Celzius",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Palce",
  "units.inchOfMercury": "Palce ortuti",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Kilometre za hodinu",
  "units.knot": "Uzly",
  "units.meterPerSecond": "Metre za sekundu",
  "units.milePerHour": "Míle za hodinu",
  "units.millibar": "Milibary",
  "units.millimeter": "Milimetre",
  "units.millimeterOfMercury": "Milimetre ortuti",
  "weatherConditions.blizzard": "Snehová víchrica",
  "weatherConditions.blowingDust": "Zvírený prach",
  "weatherConditions.blowingSnow": "Zvírený sneh",
  "weatherConditions.breezy": "Mierny vietor",
  "weatherConditions.clear": "Jasno",
  "weatherConditions.cloudy": "Zamračené",
  "weatherConditions.drizzle": "Mrholenie",
  "weatherConditions.flurries": "Slabé sneženie",
  "weatherConditions.foggy": "Hmla",
  "weatherConditions.freezingDrizzle": "Mrznúce mrholenie",
  "weatherConditions.freezingRain": "Mrznúci dážď",
  "weatherConditions.frigid": "Silný mráz",
  "weatherConditions.hail": "Krupobitie",
  "weatherConditions.haze": "Zákal",
  "weatherConditions.heavyRain": "Silný dážď",
  "weatherConditions.heavySnow": "Silné sneženie",
  "weatherConditions.hot": "Horúco",
  "weatherConditions.hurricane": "Hurikán",
  "weatherConditions.isolatedThunderstorms": "Ojedinelé búrky",
  "weatherConditions.mixedRainAndHail": "Dážď s krúpami",
  "weatherConditions.mostlyClear": "Prevažne jasno",
  "weatherConditions.mostlyCloudy": "Prevažne zamračené",
  "weatherConditions.mostlySunny": "Prevažne slnečno",
  "weatherConditions.notAvailable": "Poveternostné podmienky nie sú k dispozícii",
  "weatherConditions.partlyCloudy": "Polojasno",
  "weatherConditions.rain": "Dážď",
  "weatherConditions.rainSleet": "Dážď s ľadovými guľôčkami",
  "weatherConditions.rainSnow": "Dážď so snehom",
  "weatherConditions.scatteredShowers": "Rozptýlené prehánky",
  "weatherConditions.scatteredSnowShowers": "Rozptýlené snehové prehánky",
  "weatherConditions.scatteredThunderstorms": "Rozptýlené búrky",
  "weatherConditions.showers": "Prehánky",
  "weatherConditions.sleet": "Ľadové guľôčky",
  "weatherConditions.smoke": "Dym",
  "weatherConditions.snow": "Sneženie",
  "weatherConditions.snowShowers": "Snehové prehánky",
  "weatherConditions.strongStorms": "Silné búrky",
  "weatherConditions.sunny": "Slnečno",
  "weatherConditions.thunderstorms": "Búrky",
  "weatherConditions.tornado": "Tornádo",
  "weatherConditions.tropicalStorm": "Tropická búrka",
  "weatherConditions.windy": "Veterno",
  "weatherConditions.wintryMix": "Zmiešané zimné zrážky",
  "weatherMap.clusterMarkerName": "{metric} {value}, medián z {count, plural, one {# stanice} few {# staníc} many {# staníc} other {# staníc}}, priblížiť",
  "weatherMap.legendHeavy": "Silné",
  "weatherMap.legendLight": "Slabé",
  "weatherMap.legendLightningHelp": "Farba zobrazuje vek každého blesku za posledných {minutes} minút — najnovšie bielou, najstaršie tmavočervenou.",
  "weatherMap.legendNewest": "Najnovšie",
  "weatherMap.legendOldest": "Najstaršie",
  "weatherMap.legendStationsHelp": "Farba značky odráža hodnotu vybranej veličiny.",
  "weatherMap.lightningDataAttribution": "Údaje o bleskoch: Blitzortung.org",
  "weatherMap.lightningStrikes": "Údery bleskov",
  "weatherMap.lightningStrikesDescription": "Zobraziť údery bleskov v reálnom čase na mape",
  "weatherMap.mapLayers": "Vrstvy mapy",
  "weatherMap.mapLegend": "Legenda mapy",
  "weatherMap.mapMode": "Režim mapy",
  "weatherMap.mapNameForecast": "Predpovedná mapa, {model}, {variable}",
  "weatherMap.mapNameObservations": "Mapa počasia, pozorovania",
  "weatherMap.modeForecast": "Predpoveď",
  "weatherMap.modeObservations": "Pozorovania",
  "weatherMap.radarDataAttribution": "Údaje z radaru: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.radarTime": "Čas radaru",
  "weatherMap.rainRadar": "Dažďový radar",
  "weatherMap.rainRadarDescription": "Zobrazte na mape prekrytie dažďového radaru",
  "weatherMap.resetBearing": "Potiahnutím mapu otočíte, kliknutím ju natočíte na sever",
  "weatherMap.showingForecast": "Zobrazená predpoveď: {model}, {variable}",
  "weatherMap.signInForecastBody": "S účtom SmartMixin sú mapy GFS zadarmo. S Premium sú dostupné ďalšie modely.",
  "weatherMap.signInForecastTitle": "Prihláste sa a uvidíte predpovedné mapy",
  "weatherMap.stationMarkerName": "{metric} {value}, jedna stanica",
  "weatherMap.stationMarkersHint": "Šípkami sa presúvate medzi stanicami",
  "weatherMap.stationMarkerWindValue": "{speed}, smer {direction}",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain je dodatočný zdroj údajov poskytovaný prostredníctvom systému Tempest Weather System, ktorý využíva technológiu Nearcast. Údaje NC Rain sú odhadom priemernej akumulácie zrážok okolo vášho Tempestu na úrovni susedstva",
  "weatherMap.weatherMap": "Mapa počasia",
  "weatherMap.weatherMapMetaDescription": "SmartMixin ponúka interaktívne mapy počasia a radaru pre poveternostné podmienky po celom svete.",
  "weatherMap.zoomIn": "Priblížiť",
  "weatherMap.zoomOut": "Oddialiť",
  "weatherWarnings.activeNow": "Aktívne teraz",
  "weatherWarnings.agencyMessage": "Správa meteorologickej služby",
  "weatherWarnings.areaCovered": "Zasiahnutá oblasť",
  "weatherWarnings.areaThisLocation": "{area} (toto miesto)",
  "weatherWarnings.areaYourStation": "{area} (vaša meteorologická stanica)",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {Oficiálna výstraha, {severity}: {hazard}} one {Oficiálna výstraha, {severity}: {hazard}, a ešte #} few {Oficiálna výstraha, {severity}: {hazard}, a ešte #} other {Oficiálna výstraha, {severity}: {hazard}, a ešte #}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {Nadchádzajúca oficiálna výstraha, {severity}: {hazard}} one {Nadchádzajúca oficiálna výstraha, {severity}: {hazard}, a ešte #} few {Nadchádzajúca oficiálna výstraha, {severity}: {hazard}, a ešte #} other {Nadchádzajúca oficiálna výstraha, {severity}: {hazard}, a ešte #}}",
  "weatherWarnings.crumb": "Oficiálne výstrahy",
  "weatherWarnings.emptyBody": "Národná meteorologická služba nemá pre toto miesto žiadnu platnú výstrahu. Znova kontrolujeme každých niekoľko minút.",
  "weatherWarnings.emptyTitle": "Žiadne oficiálne výstrahy",
  "weatherWarnings.ended": "Skončená",
  "weatherWarnings.endedAt": "Táto výstraha skončila {time}.",
  "weatherWarnings.errorBody": "Skontrolujte pripojenie. Znova to skúšame každých niekoľko minút.",
  "weatherWarnings.errorTitle": "Oficiálne výstrahy sa nepodarilo načítať",
  "weatherWarnings.fromTime": "Od {time}",
  "weatherWarnings.hazardAirQuality": "Kvalita ovzdušia",
  "weatherWarnings.hazardAvalanche": "Lavíny",
  "weatherWarnings.hazardCoastalEvent": "Pobrežné javy",
  "weatherWarnings.hazardFlood": "Povodne",
  "weatherWarnings.hazardFog": "Hmla",
  "weatherWarnings.hazardForestFire": "Lesné požiare",
  "weatherWarnings.hazardHighTemperature": "Vysoké teploty",
  "weatherWarnings.hazardLowTemperature": "Nízke teploty",
  "weatherWarnings.hazardOther": "Iné nebezpečenstvo",
  "weatherWarnings.hazardRain": "Dážď",
  "weatherWarnings.hazardSnowIce": "Sneh a poľadovica",
  "weatherWarnings.hazardThunderstorm": "Búrky",
  "weatherWarnings.hazardUv": "UV žiarenie",
  "weatherWarnings.hazardWind": "Vietor",
  "weatherWarnings.hideHazards": "Skryť javy",
  "weatherWarnings.issuedBy": "Vydal: {sender}",
  "weatherWarnings.lastUpdate": "Posledná aktualizácia: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Mapa zasiahnutej oblasti: {area}.} other {Mapa zasiahnutých oblastí, spolu #. Zvýraznené: {area}.}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {Mapa zasiahnutej oblasti.} other {Mapa zasiahnutých oblastí, spolu #.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Mapa nie je k dispozícii. Oblasť je uvedená nižšie.} other {Mapa nie je k dispozícii. Zoznam oblastí (#) je uvedený nižšie.}}",
  "weatherWarnings.moreHazards": "+ ďalšie {count}: {hazards}",
  "weatherWarnings.notInLanguage": "Nie je k dispozícii v jazyku {language}. Zobrazené tak, ako to zverejnila meteorologická služba.",
  "weatherWarnings.openOn": "Otvoriť na {site}",
  "weatherWarnings.otherAreas": "{count, plural, one {+ # ďalšia oblasť} few {+ # ďalšie oblasti} other {+ # ďalších oblastí}}",
  "weatherWarnings.severityExtreme": "Extrémny",
  "weatherWarnings.severityFrom": "{severity} od {time}",
  "weatherWarnings.severityMinor": "Nízky",
  "weatherWarnings.severityModerate": "Stredný",
  "weatherWarnings.severityNow": "{severity} teraz",
  "weatherWarnings.severitySevere": "Vysoký",
  "weatherWarnings.severityUntil": "{severity} do {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {Zobraziť # oblasť} few {Zobraziť všetky # oblasti} other {Zobraziť všetkých # oblastí}}",
  "weatherWarnings.showAllOnMap": "{count, plural, one {Zobraziť # oblasť na mape} few {Zobraziť všetky # oblasti na mape} other {Zobraziť všetkých # oblastí na mape}}",
  "weatherWarnings.showHazards": "Zobraziť javy",
  "weatherWarnings.showPeriods": "{count, plural, one {Zobraziť # obdobie} few {Zobraziť všetky # obdobia} other {Zobraziť všetkých # období}}",
  "weatherWarnings.source": "Zdroj: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, potom {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# oficiálna meteorologická výstraha} few {# oficiálne meteorologické výstrahy} other {# oficiálnych meteorologických výstrah}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Oficiálne meteorologické výstrahy",
  "weatherWarnings.todayAt": "{time} dnes",
  "weatherWarnings.tomorrow": "Zajtra",
  "weatherWarnings.tomorrowAt": "{time} zajtra",
  "weatherWarnings.upcoming": "Nadchádzajúce",
  "weatherWarnings.viewAll": "Všetky oficiálne výstrahy",
  "weatherWarnings.whatToDo": "Čo robiť"
}
